import React, { useState, useEffect, useCallback, memo, cloneElement, useRef, forwardRef, isValidElement, Children, useMemo, useLayoutEffect } from 'react';
import { useSpring, animated } from 'react-spring';
import ReactModal from 'react-modal';
import ReactSelect from 'react-select';
import { cssTransition, ToastContainer, toast } from 'react-toastify';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var classnames = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

var Icon = function (_a) {
    var name = _a.name, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.dataTestId, dataTestId = _c === void 0 ? 'StyleGuideIcon' : _c, render = _a.render, style = _a.style, children = _a.children, rest = __rest(_a, ["name", "className", "dataTestId", "render", "style", "children"]);
    var icon = name ? name.replace(/^ht-/i, '') : 'logo';
    var styles = classnames(className, 'ht-icon', "ht-" + icon);
    var props = { style: style, className: styles, children: children };
    if (render)
        return render(props);
    return React.createElement("i", __assign({ "data-testid": dataTestId }, props, rest));
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = "/* SPACING SCSS */\n@use \"sass:map\";\n/* Mobile first, so mobile doesn't have a breakpoint, it starts at 0px; */\n/*  mobile grid */\n/*  tablet grid */\n/*  desktop grid */\n/*  Maps */\n/*  Mixins */\n/*  Styles for .col property are declared separately from .col-xx-xx classes */\n/* Use this to declare custom gutters in your Sass file */\n/*  Use this to declare default gutters in your Sass file */\n/**********************************************************\n\nHelpers for applying margins/padding\n\n**********************************************************/\n/*\n  A function to get spacing value given the size key and viewport.\n\n  Usage:\n\n  @import 'src/styles/global_styles/spacing';\n\n  .someClass {\n    margin-right: spacing-value(small2, 'd');\n  }\n\n  ===> Output\n\n  .someClass {\n    margin-right: 32px;\n  }\n*/\n/*\n  Generate custom padding/margin with some given values.\n\n  The general idea here is to move away from hardcoding pixel values. Since\n  the design system is using a base unit of 8px, values should be a multiple\n  of the base unit.\n\n  This mixin will take in a property name and some values. These values should be a\n  multiplier of the desired pixel value.\n\n  However, if there is some need to use pixel values, this mixin can handle it.\n\n  Usage:\n\n  @import 'src/styles/global_styles/spacing';\n\n  .someClass {\n    @include spacing(margin, 8);\n    @include spacing(padding-right, 2);\n    @include spacing(padding, 12px 2.5);\n    @include spacing(margin-bottom, 3 !important);\n  }\n\n  ===> Output\n\n  .someClass {\n    margin: 64px;\n    padding-right: 16px;\n    padding: 12px 20px;\n    margin-bottom: 24px !important;\n  }\n*/\n.Accordion_accordionContainer__r49Zg.Accordion_withBottomBorder__yBWpd {\n  border-bottom: 1px solid #edf1f7; }\n\n.Accordion_titleContainer__3kKlA {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n  cursor: pointer;\n  gap: 16px; }\n  .Accordion_titleContainer__3kKlA.Accordion_spaceBetween__2mVGu {\n    justify-content: space-between; }\n  .Accordion_titleContainer__3kKlA .Accordion_chevronIcon__3_4XQ {\n    color: #ccd4dd;\n    text-decoration: none;\n    transition: 0.1s ease-in;\n    transform-origin: 50% 50%;\n    line-height: 1.5; }\n    .Accordion_titleContainer__3kKlA .Accordion_chevronIcon__3_4XQ.Accordion_rotate__29_WI {\n      transform: rotate(90deg);\n      transition: 0.1s ease-in; }\n  .Accordion_titleContainer__3kKlA.Accordion_muted__J-53O > * {\n    pointer-events: none;\n    color: #6d7d8c;\n    opacity: 0.2; }\n  .Accordion_titleContainer__3kKlA.Accordion_faded__QIwTe .Accordion_title__XO3rs,\n  .Accordion_titleContainer__3kKlA.Accordion_faded__QIwTe .Accordion_chevronIcon__3_4XQ {\n    color: #ccd4dd; }\n  @media (hover: hover) {\n    .Accordion_titleContainer__3kKlA:hover .Accordion_title__XO3rs,\n    .Accordion_titleContainer__3kKlA:hover .Accordion_chevronIcon__3_4XQ {\n      color: #6d7d8c; } }\n\n.Accordion_iconOrder__aID3Q {\n  order: 2; }\n\n.Accordion_accordionContent__foWMW {\n  overflow: hidden;\n  transition: height 0.3s linear;\n  height: auto;\n  padding: 16px 0px 0px 32px; }\n  .Accordion_accordionContent__foWMW.Accordion_noIndentPadding__21vyu {\n    padding: 16px 0px 0px 0px; }\n  .Accordion_accordionContent__foWMW.Accordion_noContentPadding__G8DxB {\n    padding: 0; }\n  .Accordion_accordionContent__foWMW.Accordion_closed__3FVbl {\n    height: 0;\n    padding: 0px 0px 0px 32px; }\n";
var styles = {"accordionContainer":"Accordion_accordionContainer__r49Zg","withBottomBorder":"Accordion_withBottomBorder__yBWpd","titleContainer":"Accordion_titleContainer__3kKlA","spaceBetween":"Accordion_spaceBetween__2mVGu","chevronIcon":"Accordion_chevronIcon__3_4XQ","rotate":"Accordion_rotate__29_WI","muted":"Accordion_muted__J-53O","faded":"Accordion_faded__QIwTe","title":"Accordion_title__XO3rs","iconOrder":"Accordion_iconOrder__aID3Q","accordionContent":"Accordion_accordionContent__foWMW","noIndentPadding":"Accordion_noIndentPadding__21vyu","noContentPadding":"Accordion_noContentPadding__G8DxB","closed":"Accordion_closed__3FVbl"};
styleInject(css_248z);

var DEFAULT_ICON_POSITION = 'left';
var determineSetting = function (parentProp, childProp, defaultVal) {
    var isTypeLikeDefault = function (prop) { return typeof prop === typeof defaultVal; };
    if (!isTypeLikeDefault(parentProp) && !isTypeLikeDefault(childProp)) {
        return defaultVal;
    }
    return isTypeLikeDefault(childProp) ? childProp : parentProp;
};
var Accordion = function (_a) {
    var _b, _c, _d, _e;
    var _f = _a.title, title = _f === void 0 ? '' : _f, children = _a.children, childIconPosition = _a.childIconPosition, _g = _a.className, className = _g === void 0 ? '' : _g, _h = _a.dataTestId, dataTestId = _h === void 0 ? 'StyleGuideAccordion' : _h, _j = _a.onToggle, onToggle = _j === void 0 ? function () { } : _j, _k = _a.opened, opened = _k === void 0 ? false : _k, iconPosition = _a.iconPosition, _l = _a.groupHasOpenItem, groupHasOpenItem = _l === void 0 ? false : _l, _m = _a.withBottomBorder, withBottomBorder = _m === void 0 ? false : _m, noContentPadding = _a.noContentPadding, noIndentPadding = _a.noIndentPadding, noChildContentPadding = _a.noChildContentPadding, noChildIndentPadding = _a.noChildIndentPadding, selectClick = _a.selectClick, index = _a.index, alwaysOpen = _a.alwaysOpen, muted = _a.muted;
    var _o = __read(useState(opened), 2), showMore = _o[0], setShowMore = _o[1];
    useEffect(function () {
        setShowMore(opened);
        if (alwaysOpen)
            setShowMore(!!alwaysOpen);
    }, [opened]);
    var toggleAccordion = useCallback(function () {
        if (alwaysOpen || muted)
            return;
        var shouldShow = !showMore;
        setShowMore(shouldShow);
        onToggle(shouldShow);
    }, [showMore, onToggle]);
    var determinedIconPosition = determineSetting(childIconPosition, iconPosition, DEFAULT_ICON_POSITION);
    var accordionContainerStyles = classnames(styles.accordionContainer, className, 'paddingY-small1', (_b = {},
        _b[styles.withBottomBorder] = withBottomBorder,
        _b));
    var titleContainerStyles = classnames(styles.titleContainer, (_c = {},
        _c[styles.faded] = groupHasOpenItem && !opened,
        _c[styles.muted] = muted,
        _c));
    var rotationStyles = classnames(styles.chevronIcon, (_d = {},
        _d[styles.rotate] = showMore,
        _d));
    var contentStyles = classnames('p1', styles.accordionContent, (_e = {},
        _e[styles.closed] = !showMore,
        _e[styles.noContentPadding] = determineSetting(noChildContentPadding, noContentPadding, false),
        _e[styles.noIndentPadding] = determineSetting(noChildIndentPadding, noIndentPadding, false),
        _e));
    var flexOrder = determinedIconPosition === 'left' ? null : styles.iconOrder;
    var childrenWithProps = React.Children.map(children, function (child) {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, {
                selectClick: selectClick,
                index: index,
            });
        }
        return child;
    });
    return (React.createElement("div", { className: accordionContainerStyles, "data-testid": dataTestId },
        React.createElement("button", { type: "button", className: classnames('plainButton', titleContainerStyles, determinedIconPosition === 'left' ? null : styles.spaceBetween), onClick: toggleAccordion },
            React.createElement(Icon, { name: "chevron-right", className: classnames(rotationStyles, flexOrder, styles.chevronIcon) }),
            React.createElement("h5", { className: styles.title }, title)),
        React.createElement("div", { className: contentStyles }, childrenWithProps)));
};
var Accordion$1 = React.memo(Accordion);

var AccordionGroup = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, children = _a.children, _c = _a.dataTestId, dataTestId = _c === void 0 ? 'StyleGuideAccordionGroup' : _c, noContentPadding = _a.noContentPadding, noIndentPadding = _a.noIndentPadding, iconPosition = _a.iconPosition, withBottomBorder = _a.withBottomBorder;
    var _d = __read(useState(null), 2), openItem = _d[0], setOpenItem = _d[1];
    var _e = __read(useState(), 2), selectedIndex = _e[0], setSelectedIndex = _e[1];
    var selectClick = function (x) {
        setSelectedIndex(x);
    };
    var handleToggle = useCallback(function (index, visible) {
        var item = visible ? index : null;
        setOpenItem(item);
    }, []);
    return (React.createElement("div", { className: className, "data-testid": dataTestId }, children.map(function (child, index) {
        return cloneElement(child, {
            opened: openItem === index,
            onToggle: function (visible) { return handleToggle(index, visible); },
            groupHasOpenItem: Number.isInteger(openItem),
            withBottomBorder: withBottomBorder,
            selectClick: selectClick,
            index: index,
            alwaysOpen: selectedIndex === index,
            noChildContentPadding: noContentPadding,
            noChildIndentPadding: noIndentPadding,
            childIconPosition: iconPosition,
        });
    })));
};
var AccordionGroup$1 = memo(AccordionGroup);

/* eslint-disable consistent-return */
function useEventListener(p) {
    var _a = p.eventName, eventName = _a === void 0 ? '' : _a, handler = p.handler, _b = p.element, element = _b === void 0 ? window : _b;
    var savedHandler = useRef();
    useEffect(function () {
        savedHandler.current = handler;
    }, [handler]);
    useEffect(function () {
        var isSupported = element && element.addEventListener;
        if (!isSupported)
            return;
        // @ts-ignore
        var eventListener = function (event) { return savedHandler.current(event); };
        element.addEventListener(eventName, eventListener);
        return function () { return element.removeEventListener(eventName, eventListener); };
    }, [eventName, element]);
}
// https://usehooks.com/useEventListener/

var css_248z$1 = "@use \"sass:map\";\n/* Mobile first, so mobile doesn't have a breakpoint, it starts at 0px; */\n/*  mobile grid */\n/*  tablet grid */\n/*  desktop grid */\n/*  Maps */\n/*  Mixins */\n/*  Styles for .col property are declared separately from .col-xx-xx classes */\n/* Use this to declare custom gutters in your Sass file */\n/*  Use this to declare default gutters in your Sass file */\n.CalloutBox_textContent__2ERV5.CalloutBox_primary__3F3GC, .CalloutBox_textContent__2ERV5.CalloutBox_critical__1f2KS, .CalloutBox_textContent__2ERV5.CalloutBox_success__uLAOZ {\n  opacity: 0.7; }\n\n.CalloutBox_animatedContainer__RijxF {\n  overflow: hidden; }\n\n.CalloutBox_container__3xYyT {\n  display: flex;\n  width: 100%;\n  background-color: #f4f8fc; }\n  .CalloutBox_container__3xYyT.CalloutBox_primary__3F3GC {\n    background-color: #f5fbfe; }\n  .CalloutBox_container__3xYyT.CalloutBox_critical__1f2KS {\n    background-color: #fef8f8; }\n  .CalloutBox_container__3xYyT.CalloutBox_success__uLAOZ {\n    background-color: #f6fcfa; }\n\n.CalloutBox_header__mUwW1 {\n  color: #263746; }\n  .CalloutBox_header__mUwW1.CalloutBox_primary__3F3GC {\n    color: #042d49; }\n  .CalloutBox_header__mUwW1.CalloutBox_critical__1f2KS {\n    color: #511c1a; }\n  .CalloutBox_header__mUwW1.CalloutBox_success__uLAOZ {\n    color: #074f33; }\n\n.CalloutBox_textContainer__3ZcOM {\n  flex: 1; }\n\n.CalloutBox_textContent__2ERV5 {\n  color: #6d7d8c; }\n  .CalloutBox_textContent__2ERV5.CalloutBox_primary__3F3GC {\n    color: #042d49; }\n  .CalloutBox_textContent__2ERV5.CalloutBox_critical__1f2KS {\n    color: #511c1a; }\n  .CalloutBox_textContent__2ERV5.CalloutBox_success__uLAOZ {\n    color: #074f33; }\n\n.CalloutBox_highlightBar__3AS7I {\n  width: 4px;\n  background-color: #384c5e; }\n  .CalloutBox_highlightBar__3AS7I.CalloutBox_primary__3F3GC {\n    background-color: #0992e9; }\n  .CalloutBox_highlightBar__3AS7I.CalloutBox_critical__1f2KS {\n    background-color: #e64f49; }\n  .CalloutBox_highlightBar__3AS7I.CalloutBox_success__uLAOZ {\n    background-color: #00cf7f; }\n";
var styles$1 = {"textContent":"CalloutBox_textContent__2ERV5","primary":"CalloutBox_primary__3F3GC","critical":"CalloutBox_critical__1f2KS","success":"CalloutBox_success__uLAOZ","animatedContainer":"CalloutBox_animatedContainer__RijxF","container":"CalloutBox_container__3xYyT","header":"CalloutBox_header__mUwW1","textContainer":"CalloutBox_textContainer__3ZcOM","highlightBar":"CalloutBox_highlightBar__3AS7I"};
styleInject(css_248z$1);

var DefaultTextContentContainer = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: classnames(styles$1.textContent, 'paddingY-small') }, children));
};
var CalloutBoxThemes = {
    DEFAULT: 'default',
    PRIMARY: 'primary',
    CRITICAL: 'critical',
    SUCCESS: 'success',
};
var AlertBox = forwardRef(function (props, ref) {
    var _a;
    var children = props.children, className = props.className, _b = props.theme, theme = _b === void 0 ? CalloutBoxThemes.DEFAULT : _b, header = props.header, text = props.text, _c = props.textContentContainer, TextContentContainer = _c === void 0 ? DefaultTextContentContainer : _c;
    if (!text)
        return null;
    var themeStyles = (_a = {},
        _a[styles$1.primary] = theme === CalloutBoxThemes.PRIMARY,
        _a[styles$1.critical] = theme === CalloutBoxThemes.CRITICAL,
        _a[styles$1.success] = theme === CalloutBoxThemes.SUCCESS,
        _a);
    var containerStyles = classnames(styles$1.container, className, themeStyles);
    var highlightBarStyles = classnames(styles$1.highlightBar, themeStyles);
    var headerStyles = classnames(styles$1.header, 'marginBottom-tiny1', themeStyles);
    var textStyles = classnames(styles$1.text, 'p2', themeStyles);
    var textContainerStyles = classnames(styles$1.textContainer, 'paddingX-small');
    return (React.createElement("section", { className: containerStyles, ref: ref },
        React.createElement("div", { className: highlightBarStyles }),
        React.createElement("div", { className: textContainerStyles },
            React.createElement(TextContentContainer, null,
                header && React.createElement("h6", { className: headerStyles }, header),
                React.createElement("p", { className: textStyles, dangerouslySetInnerHTML: { __html: text } })),
            children && React.createElement("div", { className: "paddingBottom-small" }, children))));
});
AlertBox.displayName = 'CalloutBox';
var CalloutBox = AlertBox;

var ANIMATION_DURATION = {
    SLIDE: 200,
};
var FadeInTextContent = function (_a) {
    var children = _a.children, isParentVisible = _a.isParentVisible;
    var _b = __read(useState(false), 2), startAnimation = _b[0], setStartAnimation = _b[1];
    useEffect(function () {
        if (isParentVisible)
            setStartAnimation(true);
    }, [isParentVisible]);
    var opacity = useSpring({
        opacity: startAnimation ? 1 : 0,
    }).opacity;
    return (React.createElement(animated.div, { className: classnames(styles$1.textContent, 'paddingY-small'), style: { opacity: opacity } }, children));
};
var AnimatedCalloutBox = function (_a) {
    var _b;
    var visible = _a.visible, wrapperClassName = _a.wrapperClassName, rest = __rest(_a, ["visible", "wrapperClassName"]);
    var callBoxRef = useRef();
    var startHeight = '0';
    var _c = __read(useState(startHeight), 2), contentHeight = _c[0], setContentHeight = _c[1];
    var setNewHeight = function () {
        if (callBoxRef.current) {
            return setContentHeight(callBoxRef.current.offsetHeight || '0');
        }
        return null;
    };
    useEventListener({ eventName: 'resize', handler: setNewHeight });
    useEffect(function () {
        setNewHeight();
    }, []);
    var expand = useSpring({
        config: { duration: ANIMATION_DURATION.SLIDE },
        height: visible ? contentHeight + "px" : startHeight + "px",
    });
    // Wrap the content container in a closure so we can pass visible state from parent
    var TextContentContainer = function (props) { return React.createElement(FadeInTextContent, __assign({ isParentVisible: visible }, props)); };
    var animatedDivStyles = classnames(styles$1.animatedContainer, (_b = {}, _b[wrapperClassName] = visible, _b));
    return (React.createElement(animated.div, { style: expand, className: animatedDivStyles },
        React.createElement(CalloutBox, __assign({}, rest, { textContentContainer: TextContentContainer, ref: callBoxRef }))));
};

var css_248z$2 = "@use \"sass:map\";\n/* Mobile first, so mobile doesn't have a breakpoint, it starts at 0px; */\n/*  mobile grid */\n/*  tablet grid */\n/*  desktop grid */\n/*  Maps */\n/*  Mixins */\n/*  Styles for .col property are declared separately from .col-xx-xx classes */\n/* Use this to declare custom gutters in your Sass file */\n/*  Use this to declare default gutters in your Sass file */\n.Avatar_avatarcontainer__FJLrv {\n  width: 56px;\n  height: 56px;\n  font-size: 24px;\n  letter-spacing: -0.11px;\n  font-weight: 400;\n  display: inline-flex;\n  overflow: hidden;\n  position: relative;\n  align-items: center;\n  flex-shrink: 0;\n  line-height: 1;\n  user-select: none;\n  border-radius: 50%;\n  justify-content: center;\n  background-color: #ccd4dd;\n  color: #263746; }\n  @media screen and (min-width: 576px) {\n    .Avatar_avatarcontainer__FJLrv {\n      width: 64px;\n      height: 64px;\n      font-size: 26px;\n      letter-spacing: -0.18px; } }\n  .Avatar_avatarcontainer__FJLrv .Avatar_avatarImage__1_izV {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    text-align: center; }\n";
var styles$2 = {"avatarcontainer":"Avatar_avatarcontainer__FJLrv","avatarImage":"Avatar_avatarImage__1_izV"};
styleInject(css_248z$2);

/* Takes n number of words and returns first/last capitalized intitials */
var getInitials = function (name) {
    if (name === void 0) { name = ''; }
    var _a = name
        .toUpperCase()
        .split(' ')
        .map(([f]) => f), first = _a[0], l = _a.length, _b = l - 1, last = _a[_b];
    return "" + first + last;
};
var getLabel = function (name, imageAlt) {
    return imageAlt || "Your HelloTech Technician is " + name;
};
var getImage = function (img, name, imageAlt) { return (React.createElement("img", { className: styles$2.avatarImage, alt: getLabel(name, imageAlt), src: img })); };
var Avatar = function (_a) {
    var name = _a.name, image = _a.image, className = _a.className, imageAlt = _a.imageAlt, dataTestId = _a.dataTestId;
    if (!name && !image)
        return null;
    var body = (image && getImage(image, name, imageAlt)) || (name && getInitials(name));
    return (React.createElement("div", { className: classnames(styles$2.avatarcontainer, className), "data-testid": dataTestId }, body));
};
Avatar.defaultProps = {
    className: '',
    dataTestId: 'StyleGuideAvatar',
    name: '',
    image: '',
    imageAlt: '',
};
var Avatar$1 = React.memo(Avatar);

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
    rsComboSymbolsRange = '\\u20d0-\\u20f0',
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol$1 = root.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

var lodash_capitalize = capitalize;

var BadgeTypes;
(function (BadgeTypes) {
    BadgeTypes["success"] = "success";
    BadgeTypes["primary"] = "primary";
    BadgeTypes["neutral"] = "neutral";
    BadgeTypes["muted"] = "muted";
    BadgeTypes["warning"] = "warning";
    BadgeTypes["default"] = "neutral";
})(BadgeTypes || (BadgeTypes = {}));

var Size;
(function (Size) {
    Size["XS"] = "xsmall";
    Size["S"] = "small";
    Size["M"] = "medium";
    Size["L"] = "large";
    Size["XSMALL"] = "xsmall";
    Size["SMALL"] = "small";
    Size["MEDIUM"] = "medium";
    Size["LARGE"] = "large";
})(Size || (Size = {}));

var css_248z$3 = ".Badge_solid_success__35t20 {\n  background: rgba(0, 207, 127, 0.08);\n  color: #00cf7f; }\n\n.Badge_solid_primary__NpLlq {\n  background: rgba(9, 146, 233, 0.08);\n  color: #0992e9; }\n\n.Badge_solid_neutral__2qhAF {\n  background: rgba(38, 55, 70, 0.04);\n  color: #263746; }\n\n.Badge_solid_warning__1l5A7 {\n  background: rgba(240, 182, 74, 0.08);\n  color: #f0b64a; }\n\n.Badge_solid_muted__hAyeF {\n  background: rgba(204, 212, 221, 0.08);\n  color: #ccd4dd; }\n\n.Badge_outlined_success__3rxiF {\n  border: 1px solid #00cf7f;\n  background: rgba(0, 207, 127, 0.08);\n  color: #00cf7f; }\n\n.Badge_outlined_primary__2l_0j {\n  border: 1px solid #0992e9;\n  background: rgba(9, 146, 233, 0.08);\n  color: #0992e9; }\n\n.Badge_outlined_neutral__3P1TW {\n  border: 1px solid #263746;\n  background: rgba(38, 55, 70, 0.04);\n  color: #263746; }\n\n.Badge_outlined_warning__1kOGd {\n  border: 1px solid #f0b64a;\n  background: rgba(240, 182, 74, 0.08);\n  color: #f0b64a; }\n\n.Badge_outlined_muted__SgFkN {\n  border: 1px solid #ccd4dd;\n  background: rgba(204, 212, 221, 0.12);\n  color: #ccd4dd; }\n\n.Badge_sizeSmall__1ZpG5,\n.Badge_sizeXsmall__L8OJp {\n  display: inline;\n  height: fit-content;\n  font-weight: 550;\n  white-space: nowrap;\n  padding: 2px 8px;\n  font-size: 14px;\n  line-height: 16px;\n  letter-spacing: -0.58px;\n  border-radius: 16px; }\n\n.Badge_sizeMedium__XW5zn {\n  display: inline;\n  height: fit-content;\n  font-weight: 550;\n  white-space: nowrap;\n  padding: 4px 12px;\n  font-size: 16px;\n  line-height: 16px;\n  letter-spacing: -0.5px;\n  border-radius: 16px; }\n\n.Badge_sizeLarge__n4JCV {\n  display: inline;\n  height: fit-content;\n  font-weight: 550;\n  white-space: nowrap;\n  padding: 6px 12px;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: -0.09px;\n  border-radius: 24px; }\n";
var styles$3 = {"solid_success":"Badge_solid_success__35t20","solid_primary":"Badge_solid_primary__NpLlq","solid_neutral":"Badge_solid_neutral__2qhAF","solid_warning":"Badge_solid_warning__1l5A7","solid_muted":"Badge_solid_muted__hAyeF","outlined_success":"Badge_outlined_success__3rxiF","outlined_primary":"Badge_outlined_primary__2l_0j","outlined_neutral":"Badge_outlined_neutral__3P1TW","outlined_warning":"Badge_outlined_warning__1kOGd","outlined_muted":"Badge_outlined_muted__SgFkN","sizeSmall":"Badge_sizeSmall__1ZpG5","sizeXsmall":"Badge_sizeXsmall__L8OJp","sizeMedium":"Badge_sizeMedium__XW5zn","sizeLarge":"Badge_sizeLarge__n4JCV"};
styleInject(css_248z$3);

var getStyles = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'outlined' : _b, _c = _a.size, size = _c === void 0 ? Size.MEDIUM : _c, _d = _a.classes, classes = _d === void 0 ? '' : _d, _e = _a.type, type = _e === void 0 ? BadgeTypes.default : _e;
    var color = BadgeTypes[type];
    return classnames(styles$3[variant + "_" + color], styles$3["size" + lodash_capitalize(size)], classes);
};
var Badge = function (_a) {
    var children = _a.children, _b = _a.dataTestId, dataTestId = _b === void 0 ? 'StyleGuideBadge' : _b, rest = __rest(_a, ["children", "dataTestId"]);
    if (!children)
        return null;
    var containerStyles = getStyles(rest);
    return (React.createElement("div", { "data-testid": dataTestId, className: containerStyles }, children));
};
var Badge$1 = React.memo(Badge);

var css_248z$4 = "/* SPACING SCSS */\n@use \"sass:map\";\n/* Mobile first, so mobile doesn't have a breakpoint, it starts at 0px; */\n/*  mobile grid */\n/*  tablet grid */\n/*  desktop grid */\n/*  Maps */\n/*  Mixins */\n/*  Styles for .col property are declared separately from .col-xx-xx classes */\n/* Use this to declare custom gutters in your Sass file */\n/*  Use this to declare default gutters in your Sass file */\n/**********************************************************\n\nHelpers for applying margins/padding\n\n**********************************************************/\n/*\n  A function to get spacing value given the size key and viewport.\n\n  Usage:\n\n  @import 'src/styles/global_styles/spacing';\n\n  .someClass {\n    margin-right: spacing-value(small2, 'd');\n  }\n\n  ===> Output\n\n  .someClass {\n    margin-right: 32px;\n  }\n*/\n/*\n  Generate custom padding/margin with some given values.\n\n  The general idea here is to move away from hardcoding pixel values. Since\n  the design system is using a base unit of 8px, values should be a multiple\n  of the base unit.\n\n  This mixin will take in a property name and some values. These values should be a\n  multiplier of the desired pixel value.\n\n  However, if there is some need to use pixel values, this mixin can handle it.\n\n  Usage:\n\n  @import 'src/styles/global_styles/spacing';\n\n  .someClass {\n    @include spacing(margin, 8);\n    @include spacing(padding-right, 2);\n    @include spacing(padding, 12px 2.5);\n    @include spacing(margin-bottom, 3 !important);\n  }\n\n  ===> Output\n\n  .someClass {\n    margin: 64px;\n    padding-right: 16px;\n    padding: 12px 20px;\n    margin-bottom: 24px !important;\n  }\n*/\n.Button_button__3OKxI {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  height: 48px;\n  font-size: 16px;\n  letter-spacing: -0.4px;\n  line-height: 1.25;\n  width: 100%;\n  border-radius: 2px;\n  font-weight: 550;\n  text-align: center;\n  outline: none;\n  cursor: pointer;\n  padding: 0px 5px; }\n  .Button_button__3OKxI:disabled {\n    pointer-events: none; }\n  @media screen and (min-width: 576px) {\n    .Button_button__3OKxI {\n      padding: 0px 10px; } }\n  @media screen and (min-width: 992px) {\n    .Button_button__3OKxI {\n      padding: 0px 20px; } }\n  .Button_button__3OKxI.Button_buttonPrimary__3pYYw {\n    background: #00c9bc;\n    border: 1px solid #00c9bc;\n    color: #fff; }\n    @media (hover: hover) {\n      .Button_button__3OKxI.Button_buttonPrimary__3pYYw:hover {\n        background: #32a4ee;\n        border-color: #32a4ee;\n        color: #fff; } }\n    .Button_button__3OKxI.Button_buttonPrimary__3pYYw:disabled {\n      background: #32a4ee;\n      border-color: #32a4ee;\n      opacity: 0.45; }\n    .Button_button__3OKxI.Button_buttonPrimary__3pYYw:visited {\n      color: #fff; }\n  .Button_button__3OKxI.Button_buttonSecondary__3F230 {\n    background: transparent;\n    border: 2px solid #00c9bc;\n    color: #00c9bc; }\n    @media (hover: hover) {\n      .Button_button__3OKxI.Button_buttonSecondary__3F230:hover {\n        border: 2px solid #32a4ee;\n        color: #32a4ee; } }\n    .Button_button__3OKxI.Button_buttonSecondary__3F230:disabled {\n      background: transparent;\n      border: 2px solid #32a4ee;\n      color: #32a4ee;\n      opacity: 0.45; }\n  .Button_button__3OKxI.Button_buttonScienceBlue__2uxNS {\n    background: #004eca;\n    border: 2px solid #004eca;\n    color: #fff; }\n    @media (hover: hover) {\n      .Button_button__3OKxI.Button_buttonScienceBlue__2uxNS:hover {\n        opacity: 0.8; } }\n    .Button_button__3OKxI.Button_buttonScienceBlue__2uxNS:disabled {\n      background: #004eca;\n      border: 2px solid #004eca;\n      color: #fff;\n      opacity: 0.45; }\n  .Button_button__3OKxI.Button_buttonGradientBlue__2xSDu {\n    background: linear-gradient(to left, #1ac4f6, 50%, #0992e9);\n    border: none;\n    color: #fff; }\n    @media (hover: hover) {\n      .Button_button__3OKxI.Button_buttonGradientBlue__2xSDu:hover {\n        opacity: 0.8; } }\n    .Button_button__3OKxI.Button_buttonGradientBlue__2xSDu:disabled {\n      opacity: 0.45; }\n  .Button_button__3OKxI.Button_buttonInverted__1Pu1n {\n    background-color: white;\n    border: 2px solid #fff;\n    color: #0992e9; }\n    @media (hover: hover) {\n      .Button_button__3OKxI.Button_buttonInverted__1Pu1n:hover {\n        border-color: transparent;\n        background-color: rgba(255, 255, 255, 0.2);\n        color: #fff; } }\n    .Button_button__3OKxI.Button_buttonInverted__1Pu1n:disabled {\n      background-color: #fff;\n      color: #0992e9;\n      opacity: 0.35; }\n    .Button_button__3OKxI.Button_buttonInverted__1Pu1n:active {\n      border-color: #fff;\n      background-color: #fff;\n      color: #263746; }\n  .Button_button__3OKxI.Button_buttonTransparentWhite__3CZAk {\n    background-color: transparent;\n    border: 2px solid #fff;\n    color: #fff; }\n    @media (hover: hover) {\n      .Button_button__3OKxI.Button_buttonTransparentWhite__3CZAk:hover {\n        background-color: rgba(255, 255, 255, 0.1); } }\n    .Button_button__3OKxI.Button_buttonTransparentWhite__3CZAk:disabled {\n      background-color: transparent;\n      opacity: 0.25; }\n    .Button_button__3OKxI.Button_buttonTransparentWhite__3CZAk:active {\n      background-color: rgba(255, 255, 255, 0.1); }\n  .Button_button__3OKxI.Button_buttonDangerPrimary__1Q-Hj {\n    background: #e64f49;\n    border: 2px solid #e64f49;\n    color: #fff; }\n    @media (hover: hover) {\n      .Button_button__3OKxI.Button_buttonDangerPrimary__1Q-Hj:hover {\n        opacity: 0.8; } }\n    .Button_button__3OKxI.Button_buttonDangerPrimary__1Q-Hj:disabled {\n      background: #e64f49;\n      border: 2px solid #e64f49;\n      color: #fff;\n      opacity: 0.45; }\n  .Button_button__3OKxI.Button_buttonDangerSecondary__x7ar6 {\n    background: transparent;\n    border: 1px solid #e64f49;\n    color: #e64f49; }\n    @media (hover: hover) {\n      .Button_button__3OKxI.Button_buttonDangerSecondary__x7ar6:hover {\n        background-color: #ff726c;\n        border: 1px solid #ff726c;\n        color: #fff; } }\n    .Button_button__3OKxI.Button_buttonDangerSecondary__x7ar6:disabled {\n      background: transparent;\n      border: 1px solid #e64f49;\n      color: #e64f49;\n      opacity: 0.45; }\n  .Button_button__3OKxI.Button_buttonHuge__gyA-a {\n    height: 48px;\n    font-size: 16px;\n    letter-spacing: -0.4px;\n    line-height: 1.25; }\n    @media screen and (min-width: 992px) {\n      .Button_button__3OKxI.Button_buttonHuge__gyA-a {\n        height: 56px;\n        font-size: 18px;\n        letter-spacing: -0.5px;\n        line-height: 1.3333; } }\n  .Button_button__3OKxI.Button_buttonMedium__2I6s9 {\n    height: 48px;\n    font-size: 16px;\n    letter-spacing: -0.4px;\n    line-height: 1.25; }\n  .Button_button__3OKxI.Button_buttonSmall__1elTq {\n    height: 40px;\n    font-size: 14px;\n    letter-spacing: -0.2px;\n    line-height: 1.429; }\n  .Button_button__3OKxI.Button_inlineBlock__wMfp4 {\n    display: inline-block;\n    width: auto; }\n  .Button_button__3OKxI.Button_isLink__sc62i {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-decoration: none; }\n    @media (hover: hover) {\n      .Button_button__3OKxI.Button_isLink__sc62i:hover {\n        text-decoration: none; } }\n\n.Button_buttonText__1JR69 {\n  display: flex;\n  justify-content: center;\n  align-items: center; }\n\n.Button_iconStyles__2IjmJ {\n  margin-right: 8px;\n  padding-bottom: 2px;\n  font-size: 18px; }\n  .Button_iconStyles__2IjmJ.Button_iconHuge__VUki0 {\n    font-size: 20px; }\n  .Button_iconStyles__2IjmJ.Button_iconMedium__MHDb_ {\n    font-size: 18px; }\n  .Button_iconStyles__2IjmJ.Button_iconSmall__PQknP {\n    font-size: 16px; }\n";
var styles$4 = {"button":"Button_button__3OKxI","buttonPrimary":"Button_buttonPrimary__3pYYw","buttonSecondary":"Button_buttonSecondary__3F230","buttonScienceBlue":"Button_buttonScienceBlue__2uxNS","buttonGradientBlue":"Button_buttonGradientBlue__2xSDu","buttonInverted":"Button_buttonInverted__1Pu1n","buttonTransparentWhite":"Button_buttonTransparentWhite__3CZAk","buttonDangerPrimary":"Button_buttonDangerPrimary__1Q-Hj","buttonDangerSecondary":"Button_buttonDangerSecondary__x7ar6","buttonHuge":"Button_buttonHuge__gyA-a","buttonMedium":"Button_buttonMedium__2I6s9","buttonSmall":"Button_buttonSmall__1elTq","inlineBlock":"Button_inlineBlock__wMfp4","isLink":"Button_isLink__sc62i","buttonText":"Button_buttonText__1JR69","iconStyles":"Button_iconStyles__2IjmJ","iconHuge":"Button_iconHuge__VUki0","iconMedium":"Button_iconMedium__MHDb_","iconSmall":"Button_iconSmall__PQknP"};
styleInject(css_248z$4);

var BUTTON_THEMES = {
    DEFAULT: 'primary',
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    SCIENCEBLUE: 'scienceBlue',
    GRADIENTBLUE: 'gradientBlue',
    INVERTED: 'inverted',
    TRANSPARENTWHITE: 'transparentWhite',
    DANGER_PRIMARY: 'dangerPrimary',
    DANGER_SECONDARY: 'dangerSecondary',
};
var Button = function (_a) {
    var _b, _c;
    var _d = _a.theme, theme = _d === void 0 ? BUTTON_THEMES.DEFAULT : _d, _e = _a.huge, huge = _e === void 0 ? false : _e, _f = _a.medium, medium = _f === void 0 ? false : _f, _g = _a.small, small = _g === void 0 ? false : _g, _h = _a.inlineBlock, inlineBlock = _h === void 0 ? false : _h, _j = _a.isLink, isLink = _j === void 0 ? false : _j, _k = _a.LinkComponent, LinkComponent = _k === void 0 ? null : _k, _l = _a.dataTestId, dataTestId = _l === void 0 ? 'StyleGuideButton' : _l, _m = _a.className, className = _m === void 0 ? '' : _m, _o = _a.goTo, goTo = _o === void 0 ? '' : _o, children = _a.children, icon = _a.icon, _p = _a.iconClassName, iconClassName = _p === void 0 ? '' : _p, rest = __rest(_a, ["theme", "huge", "medium", "small", "inlineBlock", "isLink", "LinkComponent", "dataTestId", "className", "goTo", "children", "icon", "iconClassName"]);
    var buttonStyles = classnames(styles$4.button, (_b = {},
        _b[styles$4.buttonPrimary] = theme === BUTTON_THEMES.PRIMARY,
        _b[styles$4.buttonSecondary] = theme === BUTTON_THEMES.SECONDARY,
        _b[styles$4.buttonScienceBlue] = theme === BUTTON_THEMES.SCIENCEBLUE,
        _b[styles$4.buttonGradientBlue] = theme === BUTTON_THEMES.GRADIENTBLUE,
        _b[styles$4.buttonInverted] = theme === BUTTON_THEMES.INVERTED,
        _b[styles$4.buttonDangerPrimary] = theme === BUTTON_THEMES.DANGER_PRIMARY,
        _b[styles$4.buttonDangerSecondary] = theme === BUTTON_THEMES.DANGER_SECONDARY,
        _b[styles$4.buttonTransparentWhite] = theme === BUTTON_THEMES.TRANSPARENTWHITE,
        _b[styles$4.buttonHuge] = huge,
        _b[styles$4.buttonMedium] = medium,
        _b[styles$4.buttonSmall] = small,
        _b[styles$4.inlineBlock] = inlineBlock,
        _b[styles$4.isLink] = isLink,
        _b), className);
    var iconStyles = classnames(styles$4.iconStyles, (_c = {},
        _c[styles$4.iconHuge] = huge,
        _c[styles$4.iconMedium] = medium,
        _c[styles$4.iconSmall] = small,
        _c), iconClassName);
    if (isLink) {
        var newProps_1 = rest;
        if (LinkComponent) {
            return (React.createElement(LinkComponent, __assign({ to: goTo, className: buttonStyles, "data-testid": dataTestId + "-isLink" }, newProps_1), children));
        }
        return (React.createElement("a", __assign({ href: goTo, className: buttonStyles, "data-testid": dataTestId + "-isLink" }, newProps_1), children));
    }
    var newProps = rest;
    newProps.type = newProps.type || 'button';
    return (
    // eslint-disable-next-line react/button-has-type
    React.createElement("button", __assign({ className: buttonStyles, "data-testid": dataTestId }, newProps),
        React.createElement("span", { className: styles$4.buttonText },
            icon && React.createElement(Icon, { name: icon, className: iconStyles }),
            children)));
};

var css_248z$5 = "@use \"sass:map\";\n/* Mobile first, so mobile doesn't have a breakpoint, it starts at 0px; */\n/*  mobile grid */\n/*  tablet grid */\n/*  desktop grid */\n/*  Maps */\n/*  Mixins */\n/*  Styles for .col property are declared separately from .col-xx-xx classes */\n/* Use this to declare custom gutters in your Sass file */\n/*  Use this to declare default gutters in your Sass file */\n/* SPACING SCSS */\n@use \"sass:map\";\n/* Mobile first, so mobile doesn't have a breakpoint, it starts at 0px; */\n/*  mobile grid */\n/*  tablet grid */\n/*  desktop grid */\n/*  Maps */\n/*  Mixins */\n/*  Styles for .col property are declared separately from .col-xx-xx classes */\n/* Use this to declare custom gutters in your Sass file */\n/*  Use this to declare default gutters in your Sass file */\n/**********************************************************\n\nHelpers for applying margins/padding\n\n**********************************************************/\n/*\n  A function to get spacing value given the size key and viewport.\n\n  Usage:\n\n  @import 'src/styles/global_styles/spacing';\n\n  .someClass {\n    margin-right: spacing-value(small2, 'd');\n  }\n\n  ===> Output\n\n  .someClass {\n    margin-right: 32px;\n  }\n*/\n/*\n  Generate custom padding/margin with some given values.\n\n  The general idea here is to move away from hardcoding pixel values. Since\n  the design system is using a base unit of 8px, values should be a multiple\n  of the base unit.\n\n  This mixin will take in a property name and some values. These values should be a\n  multiplier of the desired pixel value.\n\n  However, if there is some need to use pixel values, this mixin can handle it.\n\n  Usage:\n\n  @import 'src/styles/global_styles/spacing';\n\n  .someClass {\n    @include spacing(margin, 8);\n    @include spacing(padding-right, 2);\n    @include spacing(padding, 12px 2.5);\n    @include spacing(margin-bottom, 3 !important);\n  }\n\n  ===> Output\n\n  .someClass {\n    margin: 64px;\n    padding-right: 16px;\n    padding: 12px 20px;\n    margin-bottom: 24px !important;\n  }\n*/\n.Checkbox_input__2Adv5 {\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px; }\n\n.Checkbox_labelWrapper__XwzBI {\n  display: flex;\n  flex-wrap: nowrap;\n  padding: 14px 0px; }\n  .Checkbox_labelWrapper__XwzBI.Checkbox_large__1fpFA {\n    padding: 14px 0px; }\n    @media screen and (min-width: 576px) {\n      .Checkbox_labelWrapper__XwzBI.Checkbox_large__1fpFA {\n        padding: 18px 0px; } }\n  .Checkbox_labelWrapper__XwzBI.Checkbox_disabled__3m4qR {\n    opacity: 0.3;\n    pointer-events: none; }\n  @media (hover: hover) {\n    .Checkbox_labelWrapper__XwzBI:hover {\n      cursor: pointer; }\n      .Checkbox_labelWrapper__XwzBI:hover .Checkbox_box__1-epL {\n        border-color: #263746; }\n        .Checkbox_labelWrapper__XwzBI:hover .Checkbox_box__1-epL.Checkbox_boxChecked__1VhVi {\n          background-color: #32a4ee;\n          border-color: #32a4ee; } }\n  .Checkbox_labelWrapper__XwzBI .Checkbox_box__1-epL {\n    height: 20px;\n    width: 20px;\n    background-color: #fff;\n    border: 1px solid #ccd4dd;\n    border-radius: 1px;\n    margin-right: 14px;\n    text-align: center; }\n    .Checkbox_labelWrapper__XwzBI .Checkbox_box__1-epL.Checkbox_boxChecked__1VhVi {\n      background-color: #0992e9;\n      border-color: #0992e9; }\n  .Checkbox_labelWrapper__XwzBI .Checkbox_icon__3YvaI {\n    display: inline-block;\n    vertical-align: middle;\n    font-size: 9px; }\n    .Checkbox_labelWrapper__XwzBI .Checkbox_icon__3YvaI::before {\n      color: #fff; }\n  .Checkbox_labelWrapper__XwzBI .Checkbox_label__RDrWr {\n    font-size: 16px;\n    font-weight: 400;\n    letter-spacing: -0.15px;\n    line-height: 1.5;\n    color: #263746; }\n    .Checkbox_labelWrapper__XwzBI .Checkbox_label__RDrWr.Checkbox_bold__2wls_ {\n      font-weight: 700; }\n    .Checkbox_labelWrapper__XwzBI .Checkbox_label__RDrWr:hover {\n      cursor: pointer; }\n\n.Checkbox_childWrapper__3vfA1 {\n  margin-left: 34px; }\n";
var styles$5 = {"input":"Checkbox_input__2Adv5","labelWrapper":"Checkbox_labelWrapper__XwzBI","large":"Checkbox_large__1fpFA","disabled":"Checkbox_disabled__3m4qR","box":"Checkbox_box__1-epL","boxChecked":"Checkbox_boxChecked__1VhVi","icon":"Checkbox_icon__3YvaI","label":"Checkbox_label__RDrWr","bold":"Checkbox_bold__2wls_","childWrapper":"Checkbox_childWrapper__3vfA1"};
styleInject(css_248z$5);

var Box = function (_a) {
    var _b;
    var checked = _a.checked, _c = _a.className, className = _c === void 0 ? '' : _c;
    var boxStyles = classnames(styles$5.box, className, (_b = {},
        _b[styles$5.boxChecked] = checked,
        _b));
    return React.createElement("div", { className: boxStyles }, checked && React.createElement(Icon, { name: "checkmark-v2", className: styles$5.icon }));
};

var inputIdCounter = 0;
/**
 Checkbox - Holds the checkmark and label

 The actual <input /> is hidden so we can customize the look of the
 checkmark box.
 */
var Checkbox = function (_a) {
    var _b, _c;
    var children = _a.children, label = _a.label, checked = _a.checked, cbValue = _a.value, disabled = _a.disabled, onCheckboxChange = _a.onCheckboxChange, _d = _a.wrapperClass, wrapperClass = _d === void 0 ? '' : _d, _e = _a.classes, classes = _e === void 0 ? '' : _e, _f = _a.labelClass, labelClass = _f === void 0 ? '' : _f, _g = _a.boxClass, boxClass = _g === void 0 ? '' : _g, _h = _a.elementSize, elementSize = _h === void 0 ? Size.S : _h, _j = _a.boldLabel, boldLabel = _j === void 0 ? false : _j, _k = _a.id, id = _k === void 0 ? '' : _k, _l = _a.dataTestId, dataTestId = _l === void 0 ? 'StyleGuideCheckbox' : _l, rest = __rest(_a, ["children", "label", "checked", "value", "disabled", "onCheckboxChange", "wrapperClass", "classes", "labelClass", "boxClass", "elementSize", "boldLabel", "id", "dataTestId"]);
    var _m = __read(useState(id), 2), inputId = _m[0], setInputId = _m[1];
    useEffect(function () {
        if (!id) {
            setInputId("Checkbox-" + inputIdCounter);
            inputIdCounter += 1;
        }
    }, []);
    var labelWrapperStyles = classnames(styles$5.labelWrapper, styles$5[elementSize], wrapperClass, (_b = {},
        _b[styles$5.disabled] = disabled,
        _b));
    var labelStyles = classnames(styles$5.label, labelClass, (_c = {},
        _c[styles$5.bold] = boldLabel,
        _c));
    return (React.createElement("div", { className: classes, "data-testid": dataTestId },
        React.createElement("label", { htmlFor: inputId, className: labelWrapperStyles },
            React.createElement("div", null,
                React.createElement("input", __assign({ id: inputId, type: "checkbox", disabled: disabled, checked: checked, onChange: onCheckboxChange === null || onCheckboxChange === void 0 ? void 0 : onCheckboxChange.bind(null, cbValue), value: cbValue, className: styles$5.input }, rest)),
                React.createElement(Box, { checked: checked, className: boxClass })),
            React.createElement("div", null,
                React.createElement("span", { className: labelStyles }, label))),
        React.createElement("div", { className: styles$5.childWrapper }, children)));
};

const hasChildren = (element) => isValidElement(element) && Boolean(element.props.children);

const hasComplexChildren = (element) => isValidElement(element) &&
    hasChildren(element) &&
    Children.toArray(element.props.children).reduce((response, child) => response || isValidElement(child), false);

const deepMap = (children, deepMapFn) => {
    return Children.toArray(children).map((child, index, mapChildren) => {
        if (isValidElement(child) && hasComplexChildren(child)) {
            // Clone the child that has children and map them too
            return deepMapFn(cloneElement(child, Object.assign(Object.assign({}, child.props), { children: deepMap(child.props.children, deepMapFn) })));
        }
        return deepMapFn(child, index, mapChildren);
    });
};

var BREAKPOINTS = {
    MD_GRID: 576,
    LG_GRID: 992,
    XL_GRID: 1440,
};
var FluidGrid = function (_a) {
    var children = _a.children, _b = _a.classes, classes = _b === void 0 ? '' : _b, _c = _a.dataTestId, dataTestId = _c === void 0 ? 'StyleGuideFluidGrid' : _c;
    var fluidGridStyles = classnames('grid', classes);
    return (React.createElement("div", { "data-testid": dataTestId, className: fluidGridStyles }, children));
};
var FullWidthGrid = function (_a) {
    var children = _a.children, _b = _a.classes, classes = _b === void 0 ? '' : _b, _c = _a.dataTestId, dataTestId = _c === void 0 ? 'StyleGuideFullGrid' : _c;
    var fullWidthGridStyles = classnames('grid-full-width', classes);
    return (React.createElement("div", { "data-testid": dataTestId, className: fullWidthGridStyles }, children));
};
var Row = function (_a) {
    var children = _a.children, _b = _a.classes, classes = _b === void 0 ? '' : _b;
    var rowStyles = classnames('row', classes);
    return React.createElement("div", { className: rowStyles }, children);
};
var Column = function (_a) {
    var _b;
    var children = _a.children, _c = _a.classes, classes = _c === void 0 ? '' : _c, sm = _a.sm, smOffset = _a.smOffset, md = _a.md, mdOffset = _a.mdOffset, lg = _a.lg, lgOffset = _a.lgOffset;
    var smStyles = sm && "col-sm-" + sm;
    var smOffsetStyles = Number.isInteger(smOffset) && "col-sm-offset-" + smOffset;
    var mdStyles = md && "col-md-" + md;
    var mdOffsetStyles = Number.isInteger(mdOffset) && "col-md-offset-" + mdOffset;
    var lgStyles = lg && "col-lg-" + lg;
    var lgOffsetStyles = Number.isInteger(lgOffset) && "col-lg-offset-" + lgOffset;
    var genericColumn = !sm && !md && !lg && 'col'; // .col is styled with flex:1
    var columnStyles = classnames((_b = {},
        _b[smStyles] = Boolean(smStyles),
        _b[smOffsetStyles] = Boolean(smOffsetStyles),
        _b[mdStyles] = Boolean(mdStyles),
        _b[mdOffsetStyles] = Boolean(mdOffsetStyles),
        _b[lgStyles] = Boolean(lgStyles),
        _b[lgOffsetStyles] = Boolean(lgOffsetStyles),
        _b[genericColumn] = Boolean(genericColumn),
        _b[classes] = Boolean(classes),
        _b));
    return React.createElement("div", { className: columnStyles }, children);
};
var Grid = {
    Fluid: FluidGrid,
    FullWidth: FullWidthGrid,
    Row: Row,
    Column: Column,
};

var css_248z$6 = ".Label_labelWrapper__nHzVY {\n  width: 100%; }\n  .Label_labelWrapper__nHzVY.Label_medium__1vm27 {\n    margin-bottom: 4px; }\n  .Label_labelWrapper__nHzVY.Label_large__2zOyH {\n    margin-bottom: 8px; }\n";
var styles$6 = {"labelWrapper":"Label_labelWrapper__nHzVY","medium":"Label_medium__1vm27","large":"Label_large__2zOyH"};
styleInject(css_248z$6);

/* eslint-disable jsx-a11y/label-has-associated-control */
/**
  Label

  Accepts a string or a custom component
*/
var Label = function (_a) {
    var _b, _c;
    var label = _a.label, _d = _a.labelComponent, labelComponent = _d === void 0 ? null : _d, _e = _a.dangerouslySetLabel, dangerouslySetLabel = _e === void 0 ? null : _e, inputId = _a.inputId, _f = _a.elementSize, elementSize = _f === void 0 ? Size.S : _f;
    if (!(label || labelComponent || dangerouslySetLabel))
        return null;
    var labelWrapperStyles = classnames(styles$6.labelWrapper, (_b = {},
        _b[styles$6.medium] = elementSize !== Size.L,
        _b[styles$6.large] = elementSize === Size.L,
        _b));
    var labelStyles = classnames((_c = {},
        _c["input-label-" + elementSize] = true,
        _c));
    var labelToRender = (React.createElement("label", { htmlFor: inputId, className: labelStyles }, label));
    if (labelComponent)
        labelToRender = labelComponent;
    if (dangerouslySetLabel) {
        labelToRender = (React.createElement("label", { htmlFor: inputId, className: labelStyles, dangerouslySetInnerHTML: { __html: dangerouslySetLabel } }));
    }
    return React.createElement("div", { className: labelWrapperStyles }, labelToRender);
};

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag$1 = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$1 = freeGlobal$1 || freeSelf$1 || Function('return this')();

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$1 = objectProto$1.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root$1.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$1(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$1(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$1(value) && objectToString$1.call(value) == symbolTag$1);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol$1(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var lodash_throttle = throttle;

var lodash_sortby = createCommonjsModule(function (module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for comparison styles. */
var UNORDERED_COMPARE_FLAG = 1,
    PARTIAL_COMPARE_FLAG = 2;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports =  exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, customizer, bitmask, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = arrayTag,
      othTag = arrayTag;

  if (!objIsArr) {
    objTag = getTag(object);
    objTag = objTag == argsTag ? objectTag : objTag;
  }
  if (!othIsArr) {
    othTag = getTag(other);
    othTag = othTag == argsTag ? objectTag : othTag;
  }
  var objIsObj = objTag == objectTag && !isHostObject(object),
      othIsObj = othTag == objectTag && !isHostObject(other),
      isSameTag = objTag == othTag;

  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
  }
  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
  };
}

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  var index = -1;
  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!seen.has(othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
              return seen.add(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, customizer, bitmask, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= UNORDERED_COMPARE_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      objProps = keys(object),
      objLength = objProps.length,
      othProps = keys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = isKey(path, object) ? [path] : castPath(path);

  var result,
      index = -1,
      length = path.length;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result) {
    return result;
  }
  var length = object ? object.length : 0;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, function(o) { return o.user; });
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
 *
 * _.sortBy(users, 'user', function(o) {
 *   return Math.floor(o.age / 10);
 * });
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = sortBy;
});

var getScreenSizes = function () {
    var width = typeof window === 'object'
        ? window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
        : null;
    var height = typeof window === 'object'
        ? window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
        : null;
    return { width: width, height: height };
};
var isMobile = function () { return getScreenSizes().width < BREAKPOINTS.MD_GRID; };
var isTablet = function () {
    var width = getScreenSizes().width;
    return width >= BREAKPOINTS.MD_GRID && width < BREAKPOINTS.LG_GRID;
};

var _a, _b;
var OPTIONS_LIMIT = 7;
var WIN_SM = 'windowSmall';
var WIN_MD = 'windowMedium';
var WIN_LG = 'windowLarge';
var NUM_COLS = (_a = {},
    _a[WIN_SM] = 1,
    _a[WIN_MD] = 2,
    _a[WIN_LG] = 3,
    _a);
var COL_PROPS = (_b = {},
    _b[WIN_SM] = { sm: 4 },
    _b[WIN_MD] = { md: 4 },
    _b[WIN_LG] = { lg: 4 },
    _b);
var breakIntoGroups = function (list, numGroups, finalList) {
    if (list === void 0) { list = []; }
    if (numGroups === void 0) { numGroups = 1; }
    if (finalList === void 0) { finalList = []; }
    if (!Array.isArray(list) || numGroups < 0)
        return list;
    var listLength = list.length;
    var listQuotient = listLength / numGroups;
    var sliceValue = listLength % numGroups === 0 ? listQuotient : listQuotient + 1;
    finalList.push(list.slice(0, sliceValue));
    var remaining = list.slice(sliceValue);
    if (remaining.length) {
        breakIntoGroups(remaining, numGroups - 1, finalList);
    }
    return finalList;
};
var determineWindowType = function () {
    if (isMobile()) {
        return WIN_SM;
    }
    if (isTablet()) {
        return WIN_MD;
    }
    return WIN_LG;
};
var useGetGroupedChildren = function (_a) {
    var children = _a.children, _b = _a.disableSort, disableSort = _b === void 0 ? false : _b, _c = _a.disableGrouping, disableGrouping = _c === void 0 ? false : _c;
    var _d = __read(useState(WIN_SM), 2), windowType = _d[0], setWindowType = _d[1];
    useEffect(function () {
        setWindowType(determineWindowType());
    }, []);
    var handleResize = useCallback(lodash_throttle(function () {
        setWindowType(determineWindowType());
    }, 300), []);
    useEventListener({ eventName: 'resize', handler: handleResize });
    var _e = useMemo(function () {
        if (Children.count(children) > OPTIONS_LIMIT && !disableGrouping) {
            // Break options into columns
            var sortFn = disableSort ? function (arr) { return arr; } : lodash_sortby;
            var sortedChildren = sortFn(children, function (child) { return child.props.label; });
            var modifiedColumnProps = __assign({}, COL_PROPS[windowType]);
            var modifiedGroupedChildren = breakIntoGroups(sortedChildren, NUM_COLS[windowType]);
            return { columnProps: modifiedColumnProps, groupedChildren: modifiedGroupedChildren };
        }
        return { columnProps: {}, groupedChildren: [children] };
    }, [children, windowType, disableSort, disableGrouping]), groupedChildren = _e.groupedChildren, columnProps = _e.columnProps;
    return {
        groupedChildren: groupedChildren,
        columnProps: columnProps,
    };
};

var CheckboxGroup = function (_a) {
    var label = _a.label, labelComponent = _a.labelComponent, dangerouslySetLabel = _a.dangerouslySetLabel, children = _a.children, checkedValues = _a.value, onChange = _a.onChange, _b = _a.disableSort, disableSort = _b === void 0 ? true : _b, _c = _a.disableGrouping, disableGrouping = _c === void 0 ? true : _c, _d = _a.containerClassName, containerClassName = _d === void 0 ? '' : _d, _e = _a.columnClassName, columnClassName = _e === void 0 ? '' : _e, _f = _a.rowClassName, rowClassName = _f === void 0 ? '' : _f, _g = _a.elementSize, elementSize = _g === void 0 ? Size.S : _g, _h = _a.dataTestId, dataTestId = _h === void 0 ? 'StyleGuideCheckboxGroup' : _h;
    // The callback for when a checkbox is clicked
    var onCheckboxChange = function (checkboxValue, event) {
        if (event.target.checked) {
            onChange(__spread(checkedValues, [checkboxValue]));
        }
        else {
            onChange(checkedValues.filter(function (v) { return v !== checkboxValue; }));
        }
    };
    // We want to pass down extra props to the children (Checkbox)
    var childrenWithExtras = deepMap(children, function (child) {
        if (child && child.type === Checkbox) {
            return cloneElement(child, __assign(__assign({}, child.props), { checked: checkedValues.includes(child.props.value), onCheckboxChange: onCheckboxChange,
                elementSize: elementSize }));
        }
        return child;
    });
    // Group the children if necessary. See the utils
    var _j = useGetGroupedChildren({
        children: childrenWithExtras,
        disableSort: disableSort,
        disableGrouping: disableGrouping,
    }), groupedChildren = _j.groupedChildren, columnProps = _j.columnProps;
    return (React.createElement("div", { className: containerClassName, "data-testid": dataTestId },
        React.createElement(Label, { elementSize: elementSize, label: label, labelComponent: labelComponent, dangerouslySetLabel: dangerouslySetLabel }),
        React.createElement(Grid.FullWidth, null,
            React.createElement(Grid.Row, { classes: rowClassName }, groupedChildren.map(function (group, i) { return (
            // eslint-disable-next-line react/no-array-index-key
            React.createElement(Grid.Column, __assign({ classes: columnClassName }, columnProps, { key: i }), group)); })))));
};
var CheckboxGroup$1 = memo(CheckboxGroup);
/**
 CheckboxGroup

 This group is used with Checkbox. If the options count exceed a certain limit,
 the options will be displayed in multiple columns instead of a single column. Also,
 the options will be sorted alphabetically when they are broken down into columns.
 Props are provided to override these default settings.

 Note:
 Checkbox must be a direct child of CheckboxGroup for this to work, or
 just take extra care if you're using a custom checkbox component.

 Props:
 label - A label of type string to render.
 labelComponent - A custom component to render for the label.
 dangerouslySetLabel - A string to dangerously set its inner html.
 value - An array of checked values
 onChange - Function to call when selecting/deselecting. The list of checked values is the first argument.
 disableSort - Disable sorting of list when breaking into multiple columns.
 disableGrouping - Disable breaking into multiple columns. Show options in a single column regardless of options count.
 size - Form size. Affects container label and list spacing

 ---------

 General Usage:

 import { Checkbox, CheckboxGroup } from 'components/Elements/Checkbox';

 ...

 const [checkedValues, setValues] = useState([]);
 const onChange = (allCheckedValues) => {
    setValues(allCheckedValues);
  };

 return (
 <CheckboxGroup
 label="An Optional Label"
 value={checkedValues}
 onChange={onChange}
 containerClassName={styles.container}
 >
 <Checkbox value={1} label="Number 1" />
 <Checkbox value={2} label="Number 2" />
 <Checkbox value={3} label="Number 3" boldLabel />
 <Checkbox value={4} label="Number 4">
 <p className="caption">Some custom component to show below the label</p>
 </Checkbox>
 </CheckboxGroup>
 );
 */

var css_248z$7 = "/* SPACING SCSS */\n@use \"sass:map\";\n/* Mobile first, so mobile doesn't have a breakpoint, it starts at 0px; */\n/*  mobile grid */\n/*  tablet grid */\n/*  desktop grid */\n/*  Maps */\n/*  Mixins */\n/*  Styles for .col property are declared separately from .col-xx-xx classes */\n/* Use this to declare custom gutters in your Sass file */\n/*  Use this to declare default gutters in your Sass file */\n/**********************************************************\n\nHelpers for applying margins/padding\n\n**********************************************************/\n/*\n  A function to get spacing value given the size key and viewport.\n\n  Usage:\n\n  @import 'src/styles/global_styles/spacing';\n\n  .someClass {\n    margin-right: spacing-value(small2, 'd');\n  }\n\n  ===> Output\n\n  .someClass {\n    margin-right: 32px;\n  }\n*/\n/*\n  Generate custom padding/margin with some given values.\n\n  The general idea here is to move away from hardcoding pixel values. Since\n  the design system is using a base unit of 8px, values should be a multiple\n  of the base unit.\n\n  This mixin will take in a property name and some values. These values should be a\n  multiplier of the desired pixel value.\n\n  However, if there is some need to use pixel values, this mixin can handle it.\n\n  Usage:\n\n  @import 'src/styles/global_styles/spacing';\n\n  .someClass {\n    @include spacing(margin, 8);\n    @include spacing(padding-right, 2);\n    @include spacing(padding, 12px 2.5);\n    @include spacing(margin-bottom, 3 !important);\n  }\n\n  ===> Output\n\n  .someClass {\n    margin: 64px;\n    padding-right: 16px;\n    padding: 12px 20px;\n    margin-bottom: 24px !important;\n  }\n*/\n.Form_form__1Hxj1 {\n  margin-bottom: -24px; }\n\n.Form_formColumn__2k0RY {\n  margin-bottom: 24px; }\n";
var styles$7 = {"form":"Form_form__1Hxj1","formColumn":"Form_formColumn__2k0RY"};
styleInject(css_248z$7);

var FormColumn = function (_a) {
    var children = _a.children, _b = _a.classes, classes = _b === void 0 ? '' : _b, rest = __rest(_a, ["children", "classes"]);
    return (React.createElement(Grid.Column, __assign({ classes: classnames(styles$7.formColumn, classes) }, rest), children));
};
var FormRow = function (_a) {
    var children = _a.children, _b = _a.classes, classes = _b === void 0 ? '' : _b, rest = __rest(_a, ["children", "classes"]);
    return (React.createElement(Grid.Row, __assign({ classes: classes }, rest), children));
};
var Form = function (_a) {
    var children = _a.children, _b = _a.classes, classes = _b === void 0 ? '' : _b, _c = _a.withoutFormTag, withoutFormTag = _c === void 0 ? false : _c, _d = _a.dataTestId, dataTestId = _d === void 0 ? 'StyleGuideForm' : _d, rest = __rest(_a, ["children", "classes", "withoutFormTag", "dataTestId"]);
    return (React.createElement(Grid.FullWidth, { classes: classes }, withoutFormTag ? (React.createElement("div", { className: styles$7.form, "data-testid": dataTestId }, children)) : (React.createElement("form", __assign({ className: styles$7.form, "data-testid": dataTestId }, rest), children))));
};
Form.Row = FormRow;
Form.Column = FormColumn;
/*
  This component is built on top of our Grid system, so it works
  similarly to the Grid components.

  The main differences are the form tag that is rendered and the
  bottom margins that are applied to each column. The negative margin
  is applied to offset the margin of the bottom row because the designs
  called for no bottom margin on the last row.

  Notes:
  Every child of <Form/> should be a group of <Form.Row><Form.Column> for
  style purposes.

  ------------

  Usage:

  import { Form, InputField, Button } from 'components/Elements/Form';

  ...

  <Form>
    <Form.Row>
      <Form.Column lg={6} md={4} sm={4}>
        <InputField />
      </Form.Column>
      <Form.Column lg={6} md={4} sm={4}>
        <InputField />
      </Form.Column>
    </Form.Row>
    <Form.Row>
      <Form.Column lg={12} md={8} sm={4}>
        <InputField />
      </Form.Column>
    </Form.Row>
    <Form.Row>
      <Form.Column lg={12} md={8} sm={4}>
        <Button>Submit</Button>
      </Form.Column>
    </Form.Row>
  </Form>
*/

var reactTextMask = createCommonjsModule(function (module, exports) {
!function(e,t){module.exports=t(React);}(commonjsGlobal,function(e){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={exports:{},id:n,loaded:!1};return e[n].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var r={};return t.m=e,t.c=r,t.p="",t(0)}([function(e,t,r){function n(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var r={};for(var n in e)t.indexOf(n)>=0||Object.prototype.hasOwnProperty.call(e,n)&&(r[n]=e[n]);return r}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return !t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t);}Object.defineProperty(t,"__esModule",{value:!0}),t.conformToMask=void 0;var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n]);}return e},l=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n);}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),f=r(3);Object.defineProperty(t,"conformToMask",{enumerable:!0,get:function(){return n(f).default}});var c=r(11),p=n(c),d=r(9),h=n(d),v=r(5),y=n(v),m=r(2),b=function(e){function t(){var e;i(this,t);for(var r=arguments.length,n=Array(r),o=0;o<r;o++)n[o]=arguments[o];var u=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(n)));return u.setRef=u.setRef.bind(u),u.onBlur=u.onBlur.bind(u),u.onChange=u.onChange.bind(u),u}return u(t,e),l(t,[{key:"setRef",value:function(e){this.inputElement=e;}},{key:"initTextMask",value:function(){var e=this.props,t=this.props.value;this.textMaskInputElement=(0, y.default)(s({inputElement:this.inputElement},e)),this.textMaskInputElement.update(t);}},{key:"componentDidMount",value:function(){this.initTextMask();}},{key:"componentDidUpdate",value:function(e){var t=this.props,r=t.value,n=t.pipe,o=t.mask,i=t.guide,a=t.placeholderChar,u=t.showMask,s={guide:i,placeholderChar:a,showMask:u},l="function"==typeof n&&"function"==typeof e.pipe?n.toString()!==e.pipe.toString():(0, m.isNil)(n)&&!(0, m.isNil)(e.pipe)||!(0, m.isNil)(n)&&(0, m.isNil)(e.pipe),f=o.toString()!==e.mask.toString(),c=Object.keys(s).some(function(t){return s[t]!==e[t]})||f||l,p=r!==this.inputElement.value;(p||c)&&this.initTextMask();}},{key:"render",value:function e(){var t=this.props,e=t.render,r=o(t,["render"]);return delete r.mask,delete r.guide,delete r.pipe,delete r.placeholderChar,delete r.keepCharPositions,delete r.value,delete r.onBlur,delete r.onChange,delete r.showMask,e(this.setRef,s({onBlur:this.onBlur,onChange:this.onChange,defaultValue:this.props.value},r))}},{key:"onChange",value:function(e){this.textMaskInputElement.update(),"function"==typeof this.props.onChange&&this.props.onChange(e);}},{key:"onBlur",value:function(e){"function"==typeof this.props.onBlur&&this.props.onBlur(e);}}]),t}(p.default.PureComponent);t.default=b,b.propTypes={mask:h.default.oneOfType([h.default.array,h.default.func,h.default.bool,h.default.shape({mask:h.default.oneOfType([h.default.array,h.default.func]),pipe:h.default.func})]).isRequired,guide:h.default.bool,value:h.default.oneOfType([h.default.string,h.default.number]),pipe:h.default.func,placeholderChar:h.default.string,keepCharPositions:h.default.bool,showMask:h.default.bool},b.defaultProps={render:function(e,t){return p.default.createElement("input",s({ref:e},t))}};},function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.placeholderChar="_",t.strFunction="function";},function(e,t,r){function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:f,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:l.placeholderChar;if(!o(e))throw new Error("Text-mask:convertMaskToPlaceholder; The mask property must be an array.");if(e.indexOf(t)!==-1)throw new Error("Placeholder character must not be used as part of the mask. Please specify a character that is not present in your mask as your placeholder character.\n\n"+("The placeholder character that was received is: "+JSON.stringify(t)+"\n\n")+("The mask that was received is: "+JSON.stringify(e)));return e.map(function(e){return e instanceof RegExp?t:e}).join("")}function o(e){return Array.isArray&&Array.isArray(e)||e instanceof Array}function i(e){return "string"==typeof e||e instanceof String}function a(e){return "number"==typeof e&&void 0===e.length&&!isNaN(e)}function u(e){return "undefined"==typeof e||null===e}function s(e){for(var t=[],r=void 0;r=e.indexOf(c),r!==-1;)t.push(r),e.splice(r,1);return {maskWithoutCaretTraps:e,indexes:t}}Object.defineProperty(t,"__esModule",{value:!0}),t.convertMaskToPlaceholder=n,t.isArray=o,t.isString=i,t.isNumber=a,t.isNil=u,t.processCaretTraps=s;var l=r(1),f=[],c="[]";},function(e,t,r){function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:s,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:u,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};if(!(0, i.isArray)(t)){if(("undefined"==typeof t?"undefined":o(t))!==a.strFunction)throw new Error("Text-mask:conformToMask; The mask property must be an array.");t=t(e,r),t=(0, i.processCaretTraps)(t).maskWithoutCaretTraps;}var n=r.guide,l=void 0===n||n,f=r.previousConformedValue,c=void 0===f?s:f,p=r.placeholderChar,d=void 0===p?a.placeholderChar:p,h=r.placeholder,v=void 0===h?(0, i.convertMaskToPlaceholder)(t,d):h,y=r.currentCaretPosition,m=r.keepCharPositions,b=l===!1&&void 0!==c,g=e.length,k=c.length,C=v.length,O=t.length,T=g-k,P=T>0,x=y+(P?-T:0),w=x+Math.abs(T);if(m===!0&&!P){for(var S=s,_=x;_<w;_++)v[_]===d&&(S+=d);e=e.slice(0,x)+S+e.slice(x,g);}for(var M=e.split(s).map(function(e,t){return {char:e,isNew:t>=x&&t<w}}),j=g-1;j>=0;j--){var E=M[j].char;if(E!==d){var R=j>=x&&k===O;E===v[R?j-T:j]&&M.splice(j,1);}}var V=s,N=!1;e:for(var A=0;A<C;A++){var B=v[A];if(B===d){if(M.length>0)for(;M.length>0;){var I=M.shift(),F=I.char,q=I.isNew;if(F===d&&b!==!0){V+=d;continue e}if(t[A].test(F)){if(m===!0&&q!==!1&&c!==s&&l!==!1&&P){for(var D=M.length,L=null,W=0;W<D;W++){var J=M[W];if(J.char!==d&&J.isNew===!1)break;if(J.char===d){L=W;break}}null!==L?(V+=F,M.splice(L,1)):A--;}else V+=F;continue e}N=!0;}b===!1&&(V+=v.substr(A,C));break}V+=B;}if(b&&P===!1){for(var U=null,H=0;H<V.length;H++)v[H]===d&&(U=H);V=null!==U?V.substr(0,U+1):s;}return {conformedValue:V,meta:{someCharsRejected:N}}}Object.defineProperty(t,"__esModule",{value:!0});var o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=n;var i=r(2),a=r(1),u=[],s="";},function(e,t){function r(e){var t=e.previousConformedValue,r=void 0===t?o:t,i=e.previousPlaceholder,a=void 0===i?o:i,u=e.currentCaretPosition,s=void 0===u?0:u,l=e.conformedValue,f=e.rawValue,c=e.placeholderChar,p=e.placeholder,d=e.indexesOfPipedChars,h=void 0===d?n:d,v=e.caretTrapIndexes,y=void 0===v?n:v;if(0===s||!f.length)return 0;var m=f.length,b=r.length,g=p.length,k=l.length,C=m-b,O=C>0,T=0===b,P=C>1&&!O&&!T;if(P)return s;var x=O&&(r===l||l===p),w=0,S=void 0,_=void 0;if(x)w=s-C;else {var M=l.toLowerCase(),j=f.toLowerCase(),E=j.substr(0,s).split(o),R=E.filter(function(e){return M.indexOf(e)!==-1});_=R[R.length-1];var V=a.substr(0,R.length).split(o).filter(function(e){return e!==c}).length,N=p.substr(0,R.length).split(o).filter(function(e){return e!==c}).length,A=N!==V,B=void 0!==a[R.length-1]&&void 0!==p[R.length-2]&&a[R.length-1]!==c&&a[R.length-1]!==p[R.length-1]&&a[R.length-1]===p[R.length-2];!O&&(A||B)&&V>0&&p.indexOf(_)>-1&&void 0!==f[s]&&(S=!0,_=f[s]);for(var I=h.map(function(e){return M[e]}),F=I.filter(function(e){return e===_}).length,q=R.filter(function(e){return e===_}).length,D=p.substr(0,p.indexOf(c)).split(o).filter(function(e,t){return e===_&&f[t]!==e}).length,L=D+q+F+(S?1:0),W=0,J=0;J<k;J++){var U=M[J];if(w=J+1,U===_&&W++,W>=L)break}}if(O){for(var H=w,Y=w;Y<=g;Y++)if(p[Y]===c&&(H=Y),p[Y]===c||y.indexOf(Y)!==-1||Y===g)return H}else if(S){for(var z=w-1;z>=0;z--)if(l[z]===_||y.indexOf(z)!==-1||0===z)return z}else for(var G=w;G>=0;G--)if(p[G-1]===c||y.indexOf(G)!==-1||0===G)return G}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var n=[],o="";},function(e,t,r){function n(e){return e&&e.__esModule?e:{default:e}}function o(e){var t={previousConformedValue:void 0,previousPlaceholder:void 0};return {state:t,update:function(r){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:e,o=n.inputElement,l=n.mask,c=n.guide,y=n.pipe,b=n.placeholderChar,g=void 0===b?h.placeholderChar:b,k=n.keepCharPositions,C=void 0!==k&&k,O=n.showMask,T=void 0!==O&&O;if("undefined"==typeof r&&(r=o.value),r!==t.previousConformedValue){("undefined"==typeof l?"undefined":s(l))===m&&void 0!==l.pipe&&void 0!==l.mask&&(y=l.pipe,l=l.mask);var P=void 0,x=void 0;if(l instanceof Array&&(P=(0, d.convertMaskToPlaceholder)(l,g)),l!==!1){var w=a(r),S=o.selectionEnd,_=t.previousConformedValue,M=t.previousPlaceholder,j=void 0;if(("undefined"==typeof l?"undefined":s(l))===h.strFunction){if(x=l(w,{currentCaretPosition:S,previousConformedValue:_,placeholderChar:g}),x===!1)return;var E=(0, d.processCaretTraps)(x),R=E.maskWithoutCaretTraps,V=E.indexes;x=R,j=V,P=(0, d.convertMaskToPlaceholder)(x,g);}else x=l;var N={previousConformedValue:_,guide:c,placeholderChar:g,pipe:y,placeholder:P,currentCaretPosition:S,keepCharPositions:C},A=(0, p.default)(w,x,N),B=A.conformedValue,I=("undefined"==typeof y?"undefined":s(y))===h.strFunction,F={};I&&(F=y(B,u({rawValue:w},N)),F===!1?F={value:_,rejected:!0}:(0, d.isString)(F)&&(F={value:F}));var q=I?F.value:B,D=(0, f.default)({previousConformedValue:_,previousPlaceholder:M,conformedValue:q,placeholder:P,rawValue:w,currentCaretPosition:S,placeholderChar:g,indexesOfPipedChars:F.indexesOfPipedChars,caretTrapIndexes:j}),L=q===P&&0===D,W=T?P:v,J=L?W:q;t.previousConformedValue=J,t.previousPlaceholder=P,o.value!==J&&(o.value=J,i(o,D));}}}}}function i(e,t){document.activeElement===e&&(b?g(function(){return e.setSelectionRange(t,t,y)},0):e.setSelectionRange(t,t,y));}function a(e){if((0, d.isString)(e))return e;if((0, d.isNumber)(e))return String(e);if(void 0===e||null===e)return v;throw new Error("The 'value' provided to Text Mask needs to be a string or a number. The value received was:\n\n "+JSON.stringify(e))}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n]);}return e},s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=o;var l=r(4),f=n(l),c=r(3),p=n(c),d=r(2),h=r(1),v="",y="none",m="object",b="undefined"!=typeof navigator&&/Android/i.test(navigator.userAgent),g="undefined"!=typeof requestAnimationFrame?requestAnimationFrame:setTimeout;},function(e,t){function r(e){return function(){return e}}var n=function(){};n.thatReturns=r,n.thatReturnsFalse=r(!1),n.thatReturnsTrue=r(!0),n.thatReturnsNull=r(null),n.thatReturnsThis=function(){return this},n.thatReturnsArgument=function(e){return e},e.exports=n;},function(e,t,r){function n(e,t,r,n,i,a,u,s){if(!e){var l;if(void 0===t)l=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {var f=[r,n,i,a,u,s],c=0;l=new Error(t.replace(/%s/g,function(){return f[c++]})),l.name="Invariant Violation";}throw l.framesToPop=1,l}}e.exports=n;},function(e,t,r){var n=r(6),o=r(7),i=r(10);e.exports=function(){function e(e,t,r,n,a,u){u!==i&&o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");}function t(){return e}e.isRequired=e;var r={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return r.checkPropTypes=n,r.PropTypes=r,r};},function(e,t,r){e.exports=r(8)();},function(e,t){var r="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=r;},function(t,r){t.exports=e;}])});
});

var MaskedInput = unwrapExports(reactTextMask);
var reactTextMask_1 = reactTextMask.reactTextMask;

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto$2.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$2 = objectProto$2.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$2.propertyIsEnumerable;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject$1(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$2;

  return value === proto;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString$2.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike$2(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject$1(value) ? objectToString$2.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$1(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$2(value) {
  return !!value && typeof value == 'object';
}

/**
 * Iterates over own and inherited enumerable string keyed properties of an
 * object and invokes `iteratee` for each property. The iteratee is invoked
 * with three arguments: (value, key, object). Iteratee functions may exit
 * iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forInRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forIn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
 */
function forIn(object, iteratee) {
  return object == null
    ? object
    : baseFor(object, typeof iteratee == 'function' ? iteratee : identity, keysIn);
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

var lodash_forin = forIn;

var lodash_map = createCommonjsModule(function (module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for comparison styles. */
var UNORDERED_COMPARE_FLAG = 1,
    PARTIAL_COMPARE_FLAG = 2;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports =  exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, customizer, bitmask, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = arrayTag,
      othTag = arrayTag;

  if (!objIsArr) {
    objTag = getTag(object);
    objTag = objTag == argsTag ? objectTag : objTag;
  }
  if (!othIsArr) {
    othTag = getTag(other);
    othTag = othTag == argsTag ? objectTag : othTag;
  }
  var objIsObj = objTag == objectTag && !isHostObject(object),
      othIsObj = othTag == objectTag && !isHostObject(other),
      isSameTag = objTag == othTag;

  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
  }
  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
  };
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!seen.has(othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
              return seen.add(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, customizer, bitmask, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= UNORDERED_COMPARE_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      objProps = keys(object),
      objLength = objProps.length,
      othProps = keys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = isKey(path, object) ? [path] : castPath(path);

  var result,
      index = -1,
      length = path.length;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result) {
    return result;
  }
  var length = object ? object.length : 0;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee));
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = map;
});

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0,
    MAX_SAFE_INTEGER$1 = 9007199254740991,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN$1 = 0 / 0;

/** `Object#toString` result references. */
var funcTag$1 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    symbolTag$2 = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim$1 = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex$1 = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary$1 = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal$1 = /^0o[0-7]+$/i;

/** Used to detect unsigned integer values. */
var reIsUint$1 = /^(?:0|[1-9]\d*)$/;

/** Built-in method references without a dependency on `root`. */
var freeParseInt$1 = parseInt;

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$3 = objectProto$3.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax$1 = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax$1(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex$1(value, length) {
  length = length == null ? MAX_SAFE_INTEGER$1 : length;
  return !!length &&
    (typeof value == 'number' || reIsUint$1.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject$2(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike$1(object) && isIndex$1(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike$1(value) {
  return value != null && isLength$1(value.length) && !isFunction$1(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$1(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject$2(value) ? objectToString$3.call(value) : '';
  return tag == funcTag$1 || tag == genTag$1;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength$1(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$2(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$3(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$2(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$3(value) && objectToString$3.call(value) == symbolTag$2);
}

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber$1(value);
  if (value === INFINITY$1 || value === -INFINITY$1) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber$1(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol$2(value)) {
    return NAN$1;
  }
  if (isObject$2(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$2(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim$1, '');
  var isBinary = reIsBinary$1.test(value);
  return (isBinary || reIsOctal$1.test(value))
    ? freeParseInt$1(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex$1.test(value) ? NAN$1 : +value);
}

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

var lodash_range = range;

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY$2 = 1 / 0,
    MAX_INTEGER$1 = 1.7976931348623157e+308,
    NAN$2 = 0 / 0;

/** `Object#toString` result references. */
var symbolTag$3 = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim$2 = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex$2 = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary$2 = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal$2 = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt$2 = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal$2 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf$2 = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$2 = freeGlobal$2 || freeSelf$2 || Function('return this')();

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$4 = objectProto$4.toString;

/** Built-in value references. */
var Symbol$2 = root$2.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : undefined,
    symbolToString$1 = symbolProto$1 ? symbolProto$1.toString : undefined;

/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString$1(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol$3(value)) {
    return symbolToString$1 ? symbolToString$1.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$2) ? '-0' : result;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$3(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$4(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$3(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$4(value) && objectToString$4.call(value) == symbolTag$3);
}

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite$1(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber$2(value);
  if (value === INFINITY$2 || value === -INFINITY$2) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER$1;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite$1(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber$2(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol$3(value)) {
    return NAN$2;
  }
  if (isObject$3(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$3(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim$2, '');
  var isBinary = reIsBinary$2.test(value);
  return (isBinary || reIsOctal$2.test(value))
    ? freeParseInt$2(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex$2.test(value) ? NAN$2 : +value);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$1(value) {
  return value == null ? '' : baseToString$1(value);
}

/**
 * Checks if `string` starts with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=0] The position to search from.
 * @returns {boolean} Returns `true` if `string` starts with `target`,
 *  else `false`.
 * @example
 *
 * _.startsWith('abc', 'a');
 * // => true
 *
 * _.startsWith('abc', 'b');
 * // => false
 *
 * _.startsWith('abc', 'b', 1);
 * // => true
 */
function startsWith(string, target, position) {
  string = toString$1(string);
  position = baseClamp(toInteger(position), 0, string.length);
  target = baseToString$1(target);
  return string.slice(position, position + target.length) == target;
}

var lodash_startswith = startsWith;

var getCardType = function (number) {
    var cards = {
        visa: /^4/,
        mastercard: /^5[1-5]/,
        amex: /^3[47]/,
        diners: /^3(?:0[0-5]|[68][0-9])/,
        discover: /^6(?:011|5[0-9]{2})/,
        jcb: /^(?:2131|1800|35\d{3})/,
    };
    var type = null;
    lodash_forin(cards, function (value, key) {
        if (cards[key].test(number)) {
            type = key;
        }
    });
    return type;
};
var phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/];
var creditCardMask = function (rawValue) {
    var cardType = getCardType(rawValue);
    var mask = [
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
    ];
    if (cardType === 'amex') {
        mask = [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/];
    }
    else if (cardType === 'diners') {
        mask = [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/];
    }
    return mask;
};
var digitsMask = function (rawValue) { return lodash_map(lodash_range((rawValue || '').length + 1), function () { return /\d/; }); };
var expirationMonthAndYearMask = [/[0-1]/, /\d/, '/', /[1-2]/, /\d/, /\d/, /\d/];
var expirationMonthAndShortYearMask = [/[0-1]/, /\d/, '/', /\d/, /\d/];
var promoCodeMask = [/./, /./, /./, /./, /./, '-', /./, /./, /./, /./, /./, '-', /./, /./, /./, /./, /./];
var nDigits = function (n) { return lodash_map(lodash_range(n), function () { return /\d/; }); };
var cvcMask = nDigits(4);
var zipCodeMask = nDigits(5);
function prepareMask(initialMask) {
    if (initialMask === 'phone')
        return phoneMask;
    if (initialMask === 'creditCard')
        return creditCardMask;
    if (initialMask === 'cvc')
        return cvcMask;
    if (initialMask === 'zip')
        return zipCodeMask;
    if (initialMask === 'digits')
        return digitsMask;
    if (initialMask === 'expirationDate')
        return expirationMonthAndYearMask;
    if (initialMask === 'expirationDateShortYear')
        return expirationMonthAndShortYearMask;
    if (initialMask === 'promoCode')
        return promoCodeMask;
    if (lodash_startswith(initialMask, 'digits:'))
        return nDigits(initialMask.split(':')[1]);
    return initialMask;
}

var css_248z$8 = ".ErrorMessage_error__16Ggy {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 1.333333333;\n  color: #ff726c; }\n";
var styles$8 = {"error":"ErrorMessage_error__16Ggy"};
styleInject(css_248z$8);

/**
  ErrorMessage

  Basic component to render error messages
*/
var ErrorMessage = function (_a) {
    var error = _a.error;
    return error ? (React.createElement("div", { "data-testid": "StyleGuideErrorMessage", role: "alert" },
        React.createElement("p", { className: styles$8.error }, error))) : null;
};

var lodash_over = createCommonjsModule(function (module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for comparison styles. */
var UNORDERED_COMPARE_FLAG = 1,
    PARTIAL_COMPARE_FLAG = 2;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports =  exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, customizer, bitmask, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = arrayTag,
      othTag = arrayTag;

  if (!objIsArr) {
    objTag = getTag(object);
    objTag = objTag == argsTag ? objectTag : objTag;
  }
  if (!othIsArr) {
    othTag = getTag(other);
    othTag = othTag == argsTag ? objectTag : othTag;
  }
  var objIsObj = objTag == objectTag && !isHostObject(object),
      othIsObj = othTag == objectTag && !isHostObject(other),
      isSameTag = objTag == othTag;

  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
  }
  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
  };
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Creates a function like `_.over`.
 *
 * @private
 * @param {Function} arrayFunc The function to iterate over iteratees.
 * @returns {Function} Returns the new over function.
 */
function createOver(arrayFunc) {
  return baseRest(function(iteratees) {
    iteratees = (iteratees.length == 1 && isArray(iteratees[0]))
      ? arrayMap(iteratees[0], baseUnary(baseIteratee))
      : arrayMap(baseFlatten(iteratees, 1), baseUnary(baseIteratee));

    return baseRest(function(args) {
      var thisArg = this;
      return arrayFunc(iteratees, function(iteratee) {
        return apply(iteratee, thisArg, args);
      });
    });
  });
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!seen.has(othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
              return seen.add(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, customizer, bitmask, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= UNORDERED_COMPARE_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      objProps = keys(object),
      objLength = objProps.length,
      othProps = keys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = isKey(path, object) ? [path] : castPath(path);

  var result,
      index = -1,
      length = path.length;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result) {
    return result;
  }
  var length = object ? object.length : 0;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * Creates a function that invokes `iteratees` with the arguments it receives
 * and returns their results.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to invoke.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var func = _.over([Math.max, Math.min]);
 *
 * func(1, 2, 3, 4);
 * // => [4, 1]
 */
var over = createOver(arrayMap);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = over;
});

/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */
function compact(array) {
  var index = -1,
      length = array ? array.length : 0,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value) {
      result[resIndex++] = value;
    }
  }
  return result;
}

var lodash_compact = compact;

/**
 * lodash 3.0.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.7.0 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @alias head
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.first([1, 2, 3]);
 * // => 1
 *
 * _.first([]);
 * // => undefined
 */
function first(array) {
  return array ? array[0] : undefined;
}

var lodash_first = first;

var css_248z$9 = "/* SPACING SCSS */\n@use \"sass:map\";\n/* Mobile first, so mobile doesn't have a breakpoint, it starts at 0px; */\n/*  mobile grid */\n/*  tablet grid */\n/*  desktop grid */\n/*  Maps */\n/*  Mixins */\n/*  Styles for .col property are declared separately from .col-xx-xx classes */\n/* Use this to declare custom gutters in your Sass file */\n/*  Use this to declare default gutters in your Sass file */\n/**********************************************************\n\nHelpers for applying margins/padding\n\n**********************************************************/\n/*\n  A function to get spacing value given the size key and viewport.\n\n  Usage:\n\n  @import 'src/styles/global_styles/spacing';\n\n  .someClass {\n    margin-right: spacing-value(small2, 'd');\n  }\n\n  ===> Output\n\n  .someClass {\n    margin-right: 32px;\n  }\n*/\n/*\n  Generate custom padding/margin with some given values.\n\n  The general idea here is to move away from hardcoding pixel values. Since\n  the design system is using a base unit of 8px, values should be a multiple\n  of the base unit.\n\n  This mixin will take in a property name and some values. These values should be a\n  multiplier of the desired pixel value.\n\n  However, if there is some need to use pixel values, this mixin can handle it.\n\n  Usage:\n\n  @import 'src/styles/global_styles/spacing';\n\n  .someClass {\n    @include spacing(margin, 8);\n    @include spacing(padding-right, 2);\n    @include spacing(padding, 12px 2.5);\n    @include spacing(margin-bottom, 3 !important);\n  }\n\n  ===> Output\n\n  .someClass {\n    margin: 64px;\n    padding-right: 16px;\n    padding: 12px 20px;\n    margin-bottom: 24px !important;\n  }\n*/\n/*\n  Spinning Bubbles Loader\n*/\n.Loaders_spinningBubbles__3WMim {\n  color: #32a4ee;\n  font-size: 5px;\n  margin: 0 auto;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  position: relative;\n  text-indent: -9999em;\n  animation: Loaders_loadBubbles__2Ni_6 1.3s infinite linear;\n  transform: translateZ(0); }\n  .Loaders_spinningBubbles__3WMim.Loaders_small__cBZlv {\n    font-size: 4px;\n    width: 6px;\n    height: 6px; }\n\n@keyframes Loaders_loadBubbles__2Ni_6 {\n  0%,\n  100% {\n    box-shadow: 0 -3em 0 0.2em, 2em -2em 0 0, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 0; }\n  12.5% {\n    box-shadow: 0 -3em 0 0, 2em -2em 0 0.2em, 3em 0 0 0, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em; }\n  25% {\n    box-shadow: 0 -3em 0 -0.5em, 2em -2em 0 0, 3em 0 0 0.2em, 2em 2em 0 0, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em; }\n  37.5% {\n    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 0, 2em 2em 0 0.2em, 0 3em 0 0, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em; }\n  50% {\n    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 0, 0 3em 0 0.2em, -2em 2em 0 0, -3em 0 0 -1em, -2em -2em 0 -1em; }\n  62.5% {\n    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 0, -2em 2em 0 0.2em, -3em 0 0 0, -2em -2em 0 -1em; }\n  75% {\n    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0 0 0.2em, -2em -2em 0 0; }\n  87.5% {\n    box-shadow: 0 -3em 0 0, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0 0 0, -2em -2em 0 0.2em; } }\n\n/*\n  Column Loader\n*/\n.Loaders_columnLoader__1Tng5,\n.Loaders_columnLoader__1Tng5::before,\n.Loaders_columnLoader__1Tng5::after {\n  background: #fdfcfc;\n  -webkit-animation: Loaders_columnloaderkey__UVLeG 1s infinite ease-in-out;\n  animation: Loaders_columnLoaderKey__2S3qK 1s infinite ease-in-out;\n  width: 1em;\n  height: 4em; }\n\n.Loaders_columnLoader__1Tng5 {\n  color: #fdfcfc;\n  text-indent: -9999em;\n  margin: 88px auto;\n  position: relative;\n  font-size: 11px;\n  -webkit-transform: translateZ(0);\n  -ms-transform: translateZ(0);\n  transform: translateZ(0);\n  -webkit-animation-delay: -0.16s;\n  animation-delay: -0.16s; }\n\n.Loaders_columnLoader__1Tng5::before,\n.Loaders_columnLoader__1Tng5::after {\n  position: absolute;\n  top: 0;\n  content: ''; }\n\n.Loaders_columnLoader__1Tng5::before {\n  left: -1.5em;\n  -webkit-animation-delay: -0.32s;\n  animation-delay: -0.32s; }\n\n.Loaders_columnLoader__1Tng5::after {\n  left: 1.5em; }\n\n@keyframes Loaders_columnLoaderKey__2S3qK {\n  0%,\n  80%,\n  100% {\n    box-shadow: 0 0;\n    height: 4em; }\n  40% {\n    box-shadow: 0 -2em;\n    height: 5em; } }\n\n/*\n  Loaders.Page\n*/\n.Loaders_wrapper__vzyO4 {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  z-index: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center; }\n\n/*\n  Loaders.Component\n*/\n.Loaders_loadingComponentContainer__2Avio {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center; }\n  .Loaders_loadingComponentContainer__2Avio div:not(:first-child) {\n    padding-top: 48px; }\n";
var styles$9 = {"spinningBubbles":"Loaders_spinningBubbles__3WMim","loadBubbles":"Loaders_loadBubbles__2Ni_6","small":"Loaders_small__cBZlv","columnLoader":"Loaders_columnLoader__1Tng5","columnloaderkey":"Loaders_columnloaderkey__UVLeG","columnLoaderKey":"Loaders_columnLoaderKey__2S3qK","wrapper":"Loaders_wrapper__vzyO4","loadingComponentContainer":"Loaders_loadingComponentContainer__2Avio"};
styleInject(css_248z$9);

var LoadersComponent = function (_a) {
    var _b;
    var _c = _a === void 0 ? {} : _a, _d = _c.primary, primary = _d === void 0 ? false : _d, _e = _c.className, className = _e === void 0 ? '' : _e, _f = _c.message, message = _f === void 0 ? '' : _f, _g = _c.messageClassName, messageClassName = _g === void 0 ? '' : _g, _h = _c.loaderSize, loaderSize = _h === void 0 ? '' : _h, _j = _c.containerClassName, containerClassName = _j === void 0 ? '' : _j;
    var loaderType = classnames(className, (_b = {},
        _b[styles$9.columnLoader] = primary,
        _b[styles$9.spinningBubbles] = !primary,
        _b[styles$9[loaderSize]] = true,
        _b));
    return (React.createElement("div", { className: classnames(styles$9.loadingComponentContainer, containerClassName) },
        React.createElement("div", { className: loaderType }),
        message && React.createElement("div", { className: classnames('p2', messageClassName) }, message)));
};

var css_248z$a = ".Input_inputField__o246v .Input_inputWrapper__2fG9p {\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  border: 1px #ccd4dd solid;\n  border-radius: 2px; }\n  .Input_inputField__o246v .Input_inputWrapper__2fG9p.Input_withError__V-_R8 {\n    border-color: #ff726c; }\n  @media (hover: hover) {\n    .Input_inputField__o246v .Input_inputWrapper__2fG9p:hover {\n      border-color: #263746; } }\n  .Input_inputField__o246v .Input_inputWrapper__2fG9p:focus-within {\n    border-color: #32a4ee; }\n  .Input_inputField__o246v .Input_inputWrapper__2fG9p.Input_disabled__2v42K {\n    opacity: 0.3;\n    pointer-events: none;\n    border: 1px solid #6d7d8c;\n    background-color: #ccd4dd; }\n\n.Input_inputField__o246v input.Input_input__Ns1bn {\n  background-color: transparent;\n  outline: none;\n  width: 100%;\n  margin: 0;\n  border: none;\n  color: #263746;\n  font-weight: 400;\n  letter-spacing: -0.15px; }\n  .Input_inputField__o246v input.Input_input__Ns1bn.Input_xsmall__3PIHD {\n    padding: 7px 12px;\n    font-size: 14px;\n    letter-spacing: -0.12px;\n    line-height: 1.429; }\n  .Input_inputField__o246v input.Input_input__Ns1bn.Input_small__2pSpI {\n    padding: 7px 12px;\n    font-size: 16px;\n    letter-spacing: -0.15px;\n    line-height: 1.5; }\n  .Input_inputField__o246v input.Input_input__Ns1bn.Input_medium__2triR {\n    padding: 11px 12px;\n    font-size: 16px;\n    letter-spacing: -0.15px;\n    line-height: 1.5; }\n  .Input_inputField__o246v input.Input_input__Ns1bn.Input_large__1dtXV {\n    padding: 13px 16px;\n    font-size: 20px;\n    letter-spacing: -0.25px;\n    line-height: 1.4; }\n  .Input_inputField__o246v input.Input_input__Ns1bn.Input_withIcon__QSCPa {\n    padding-right: 8px; }\n\n.Input_inputField__o246v .Input_loaderContainer__39h2i {\n  width: 52px; }\n\n.Input_inputField__o246v .Input_postfixIconWrapper__bTV7n.Input_inputsmall__beRJz, .Input_inputField__o246v .Input_postfixIconWrapper__bTV7n.Input_inputmedium__11pZ3 {\n  padding-right: 12px; }\n\n.Input_inputField__o246v .Input_postfixIconWrapper__bTV7n.Input_inputlarge__337Pe {\n  padding-right: 16px; }\n\n.Input_inputField__o246v .Input_postfixIconWrapper__bTV7n .Input_postfixIcon__2it1e {\n  font-size: 20px; }\n\n.Input_inputField__o246v .Input_postfixIconWrapper__bTV7n .Input_errorIcon__nKi_V {\n  color: #ff726c; }\n\n.Input_inputField__o246v .Input_postfixIconWrapper__bTV7n .Input_iconButton__39Kao {\n  cursor: pointer; }\n\n.Input_inputField__o246v .Input_error__3nNrv {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 1.333333333;\n  color: #ff726c; }\n";
var styles$a = {"inputField":"Input_inputField__o246v","inputWrapper":"Input_inputWrapper__2fG9p","withError":"Input_withError__V-_R8","disabled":"Input_disabled__2v42K","input":"Input_input__Ns1bn","xsmall":"Input_xsmall__3PIHD","small":"Input_small__2pSpI","medium":"Input_medium__2triR","large":"Input_large__1dtXV","withIcon":"Input_withIcon__QSCPa","loaderContainer":"Input_loaderContainer__39h2i","postfixIconWrapper":"Input_postfixIconWrapper__bTV7n","inputsmall":"Input_inputsmall__beRJz","inputmedium":"Input_inputmedium__11pZ3","inputlarge":"Input_inputlarge__337Pe","postfixIcon":"Input_postfixIcon__2it1e","errorIcon":"Input_errorIcon__nKi_V","iconButton":"Input_iconButton__39Kao","error":"Input_error__3nNrv"};
styleInject(css_248z$a);

var prevented = function (fn) { return function (event) {
    event.preventDefault();
    fn();
}; };
/*
  Loader Icon
  This will take precedence over other icon settings.
*/
var getLoaderIcon = function (_a) {
    var showLoader = _a.showLoader;
    return showLoader ? React.createElement(LoadersComponent, { loaderSize: "small", containerClassName: styles$a.loaderContainer }) : null;
};
/*
  Error Icon
  If there's an error, then show this icon.
*/
var getErrorIcon = function (_a) {
    var _b = _a.hasError, hasError = _b === void 0 ? false : _b, wrapperStyles = _a.wrapperStyles;
    return hasError ? (React.createElement("div", { className: wrapperStyles },
        React.createElement(Icon, { name: "info-filled", className: classnames(styles$a.postfixIcon, styles$a.errorIcon) }))) : null;
};
/*
  Icon
  Given an iconName, render this component. A ref must be passed to <InputFieldV2 /> to
  access it in the callback function.
  Usage:
  <InputFieldV2
    ...
    ref={inputRef}
    iconName="v2-green-checkmark"
    iconClass={styles.icon}
    iconOnClick={(inputRef) => { console.log('do something with the ref. maybe.') }}
  />
*/
var getIcon = function (_a) {
    var _b = _a.iconName, iconName = _b === void 0 ? '' : _b, _c = _a.iconClass, iconClass = _c === void 0 ? '' : _c, _d = _a.iconOnClick, iconOnClick = _d === void 0 ? null : _d, wrapperStyles = _a.wrapperStyles, inputRef = _a.inputRef;
    if (!iconName)
        return null;
    var onClickCB = iconOnClick
        ? prevented(function () {
            iconOnClick(inputRef);
        })
        : null;
    var component = React.createElement(Icon, { name: iconName, className: classnames(styles$a.postfixIcon, iconClass) });
    return onClickCB ? (React.createElement("button", { type: "button", className: classnames('plainButton', styles$a.iconButton, wrapperStyles), onClick: onClickCB }, component)) : (React.createElement("div", { className: wrapperStyles }, component));
};
/*
  Custom Icon Component
  Pass a custom component to render. A ref must be passed to <InputFieldV2 /> to
  access it as a prop in the custom icon component.
  Usage:
  const SomethingCustom = ({ inputRef }) => {
    console.log(inputRef);
    return <p>Help</p>;
  };
  const inputRef = useRef();
  ....
  <InputFieldV2
    ...
    ref={inputRef}
    iconComponent={<SomethingCustom />}
  />
*/
var getIconComponent = function (_a) {
    var _b = _a.iconComponent, iconComponent = _b === void 0 ? null : _b, inputRef = _a.inputRef, wrapperStyles = _a.wrapperStyles;
    if (!iconComponent)
        return null;
    var modifiedIconComponent = cloneElement(iconComponent, {
        inputRef: inputRef,
    });
    return React.createElement("div", { className: wrapperStyles }, modifiedIconComponent);
};
/**
 Postfix Icon
 Icon to show on the right-hand side of the input.
 Notes:
 - If there is an error, the error icon will take precedence.
 */
// Helpers
var iterateIconGetters = lodash_over(getLoaderIcon, getErrorIcon, getIcon, getIconComponent);
var iterateIconGettersCustom = lodash_over(getIcon, getErrorIcon, getIconComponent);
var getIconToRender = function (props) {
    var _a = props.showError, showError = _a === void 0 ? true : _a;
    var iconGetters = iterateIconGetters;
    if (!showError) {
        iconGetters = iterateIconGettersCustom;
    }
    return lodash_first(lodash_compact(iconGetters(props))) || null;
};
var PostfixIcon = function (_a) {
    var _b;
    var inputRef = _a.inputRef, size = _a.size, rest = __rest(_a, ["inputRef", "size"]);
    var wrapperStyles = classnames(styles$a.postfixIconWrapper, (_b = {},
        _b[styles$a["input" + size]] = true,
        _b));
    return getIconToRender(__assign({ inputRef: inputRef, wrapperStyles: wrapperStyles }, rest));
};
var PostfixIcon$1 = memo(PostfixIcon);

/**
 InputWrapper - Wrapper around <input /> and <PostfixIcon />
 */
var InputWrapper = function (_a) {
    var _b, _c;
    var _d = _a.elementSize, elementSize = _d === void 0 ? Size.MEDIUM : _d, inputId = _a.inputId, defaultValue = _a.defaultValue, _e = _a.onChange, onChange = _e === void 0 ? function () { } : _e, _f = _a.placeholder, placeholder = _f === void 0 ? '' : _f, _g = _a.mask, mask = _g === void 0 ? '' : _g, _h = _a.guide, guide = _h === void 0 ? true : _h, _j = _a.inputWrapperClass, inputWrapperClass = _j === void 0 ? '' : _j, inputRef = _a.inputRef, error = _a.error, iconName = _a.iconName, iconClass = _a.iconClass, iconOnClick = _a.iconOnClick, iconComponent = _a.iconComponent, _k = _a.showLoader, showLoader = _k === void 0 ? false : _k, _l = _a.dataTestIdInput, dataTestIdInput = _l === void 0 ? 'StyleGuideInput' : _l, disabled = _a.disabled, _m = _a.showError, showError = _m === void 0 ? true : _m, rest = __rest(_a, ["elementSize", "inputId", "defaultValue", "onChange", "placeholder", "mask", "guide", "inputWrapperClass", "inputRef", "error", "iconName", "iconClass", "iconOnClick", "iconComponent", "showLoader", "dataTestIdInput", "disabled", "showError"]);
    var hasMask = !!mask;
    var maskType = prepareMask(mask);
    var hasError = !!error;
    var onChangeCB = useCallback(function (event) { return onChange(event); }, []);
    // Set default value
    useEffect(function () {
        if (defaultValue) {
            var target = {
                target: { value: defaultValue },
            };
            onChange(target);
        }
    }, []);
    // Styles
    var inputWrapperStyles = classnames(styles$a.inputWrapper, inputWrapperClass, (_b = {},
        _b[styles$a.withError] = hasError,
        _b[styles$a.disabled] = !!disabled,
        _b));
    var inputStyles = classnames(styles$a.input, styles$a[elementSize], (_c = {},
        _c[styles$a.withIcon] = hasError || iconName,
        _c));
    return (React.createElement("div", { className: inputWrapperStyles },
        !hasMask ? (React.createElement("input", __assign({ "data-testid": dataTestIdInput, id: inputId, ref: inputRef, className: inputStyles, defaultValue: defaultValue, onChange: onChangeCB, placeholder: placeholder, autoComplete: "off", disabled: disabled }, rest))) : (React.createElement(MaskedInput, __assign({ "data-testid": dataTestIdInput, id: inputId, ref: inputRef, className: inputStyles, defaultValue: defaultValue, onChange: onChangeCB, placeholder: placeholder, autoComplete: "off", mask: maskType, guide: guide, placeholderChar: '\u2000', disabled: disabled }, rest))),
        React.createElement(PostfixIcon$1, { inputRef: inputRef, hasError: hasError, size: elementSize, iconName: iconName, iconClass: iconClass, iconOnClick: iconOnClick, iconComponent: iconComponent, showLoader: showLoader, showError: showError })));
};
var inputIdCounter$1 = 0;
var InputField = forwardRef(function (_a, inputRef) {
    var _b = _a.elementSize, elementSize = _b === void 0 ? Size.MEDIUM : _b, _c = _a.containerClass, containerClass = _c === void 0 ? '' : _c, label = _a.label, labelComponent = _a.labelComponent, dangerouslySetLabel = _a.dangerouslySetLabel, error = _a.error, id = _a.id, _d = _a.dataTestId, dataTestId = _d === void 0 ? 'StyleGuideInputField' : _d, restProps = __rest(_a, ["elementSize", "containerClass", "label", "labelComponent", "dangerouslySetLabel", "error", "id", "dataTestId"]);
    var _e = __read(useState(id), 2), inputId = _e[0], setInputId = _e[1];
    // set id for <input />
    useEffect(function () {
        if (!id) {
            setInputId("Input-" + inputIdCounter$1);
            inputIdCounter$1 += 1;
        }
    }, []);
    return (React.createElement("div", { className: classnames(styles$a.inputField, containerClass), "data-testid": dataTestId },
        React.createElement(Label, { elementSize: elementSize, label: label, labelComponent: labelComponent, dangerouslySetLabel: dangerouslySetLabel, inputId: inputId }),
        React.createElement(InputWrapper, __assign({ inputRef: inputRef, elementSize: elementSize, error: error, inputId: inputId }, restProps)),
        React.createElement(ErrorMessage, { error: error })));
});
InputField.displayName = 'InputField';
/*
  Doing some weird hack so that the docs can generate the args table.
*/
var Input = InputField;

var LoadersPage = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.primary, primary = _c === void 0 ? false : _c;
    return (React.createElement("div", { className: styles$9.wrapper + " " + className },
        React.createElement(LoadersComponent, { primary: primary })));
};
/*
  This requires the parent container to have `position`
  set to `relative`.
*/

var css_248z$b = "/* stylelint-disable no-descending-specificity */\n/* SPACING SCSS */\n@use \"sass:map\";\n/* Mobile first, so mobile doesn't have a breakpoint, it starts at 0px; */\n/*  mobile grid */\n/*  tablet grid */\n/*  desktop grid */\n/*  Maps */\n/*  Mixins */\n/*  Styles for .col property are declared separately from .col-xx-xx classes */\n/* Use this to declare custom gutters in your Sass file */\n/*  Use this to declare default gutters in your Sass file */\n/**********************************************************\n\nHelpers for applying margins/padding\n\n**********************************************************/\n/*\n  A function to get spacing value given the size key and viewport.\n\n  Usage:\n\n  @import 'src/styles/global_styles/spacing';\n\n  .someClass {\n    margin-right: spacing-value(small2, 'd');\n  }\n\n  ===> Output\n\n  .someClass {\n    margin-right: 32px;\n  }\n*/\n/*\n  Generate custom padding/margin with some given values.\n\n  The general idea here is to move away from hardcoding pixel values. Since\n  the design system is using a base unit of 8px, values should be a multiple\n  of the base unit.\n\n  This mixin will take in a property name and some values. These values should be a\n  multiplier of the desired pixel value.\n\n  However, if there is some need to use pixel values, this mixin can handle it.\n\n  Usage:\n\n  @import 'src/styles/global_styles/spacing';\n\n  .someClass {\n    @include spacing(margin, 8);\n    @include spacing(padding-right, 2);\n    @include spacing(padding, 12px 2.5);\n    @include spacing(margin-bottom, 3 !important);\n  }\n\n  ===> Output\n\n  .someClass {\n    margin: 64px;\n    padding-right: 16px;\n    padding: 12px 20px;\n    margin-bottom: 24px !important;\n  }\n*/\n.Modal_overlay__2hRy4 {\n  overflow: auto;\n  position: fixed;\n  z-index: 1990;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.3); }\n  @media screen and (min-width: 576px) {\n    .Modal_overlay__2hRy4 {\n      padding: 24px; } }\n\n.Modal_slideUp__3mKs6 {\n  animation: Modal_slideup__3fNty 0.2s ease-in-out; }\n\n.Modal_slideDown__TKAh1 {\n  animation: Modal_slidedown__1aVT8 0.2s linear; }\n\n@keyframes Modal_slideup__3fNty {\n  0% {\n    transform: translateY(100%); }\n  100% {\n    transform: translateY(0); } }\n\n@keyframes Modal_slidedown__1aVT8 {\n  0% {\n    transform: translateY(0); }\n  100% {\n    transform: translateY(100%); } }\n\n/**\n  Modal\n*/\n.Modal_commonModalStyles__1kPRh {\n  display: flex;\n  flex-direction: column;\n  outline: none;\n  overflow: hidden;\n  height: 100%;\n  max-height: 100%;\n  width: 100%;\n  padding: 32px;\n  background-color: #fff; }\n  @media screen and (min-width: 576px) {\n    .Modal_commonModalStyles__1kPRh {\n      height: auto;\n      border-radius: 4px; }\n      .Modal_commonModalStyles__1kPRh.Modal_slideUp__3mKs6 {\n        animation: none; }\n      .Modal_commonModalStyles__1kPRh.Modal_slideDown__TKAh1 {\n        animation: none; } }\n  .Modal_commonModalStyles__1kPRh .Modal_headerContainer__QPV60,\n  .Modal_commonModalStyles__1kPRh .Modal_footerContainer__1fxO- {\n    flex-shrink: 0; }\n  .Modal_commonModalStyles__1kPRh .Modal_bodyContainer__143Zl {\n    flex: 1; }\n\n@media screen and (min-width: 576px) {\n  .Modal_modalLarge__3MCf_ {\n    max-width: 640px;\n    padding: 40px; } }\n\n@media screen and (min-width: 992px) {\n  .Modal_modalLarge__3MCf_ {\n    max-width: 880px;\n    padding: 48px; } }\n\n@media screen and (min-width: 576px) {\n  .Modal_modalMedium__129Iu {\n    max-width: 640px;\n    padding: 40px; } }\n\n@media screen and (min-width: 576px) {\n  .Modal_modalSmall__2j5Eu {\n    max-width: 375px; } }\n\n.Modal_modalSmall__2j5Eu .Modal_footerContainer__1fxO- {\n  flex-direction: column; }\n\n.Modal_modalSmall__2j5Eu .Modal_footer2and3Container__2YwV1 {\n  flex-direction: column; }\n\n.Modal_modalSmall__2j5Eu .Modal_footerElement2and3__2hc7M {\n  margin-top: 16px; }\n  @media screen and (min-width: 576px) {\n    .Modal_modalSmall__2j5Eu .Modal_footerElement2and3__2hc7M {\n      margin-left: 0;\n      margin-top: 16px; } }\n\n/*\n  Header Section\n*/\n.Modal_headerContainer__QPV60 {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 32px; }\n  @media screen and (min-width: 576px) {\n    .Modal_headerContainer__QPV60 {\n      margin-bottom: 40px; } }\n\n.Modal_headers__1juvz {\n  flex: 1; }\n\n.Modal_modalCloseButton__xOz-- {\n  align-self: flex-start;\n  appearance: none;\n  padding: 0;\n  background-color: transparent;\n  border: none;\n  margin: 0; }\n  .Modal_modalCloseButton__xOz--:focus, .Modal_modalCloseButton__xOz--:active {\n    outline: none; }\n  @media (hover: hover) {\n    .Modal_modalCloseButton__xOz--:hover {\n      cursor: pointer; } }\n\n.Modal_modalCloseIcon__3Wy-Z {\n  font-size: 18px;\n  color: #ccd4dd; }\n  @media (hover: hover) {\n    .Modal_modalCloseIcon__3Wy-Z:hover {\n      color: #6d7d8c; } }\n\n/*\n  Body Section\n*/\n.Modal_bodyContainer__143Zl {\n  overflow-y: auto;\n  padding-bottom: 2px;\n  -webkit-overflow-scrolling: touch; }\n  .Modal_bodyContainer__143Zl + .Modal_footerContainer__1fxO- {\n    margin-top: 32px; }\n    @media screen and (min-width: 576px) {\n      .Modal_bodyContainer__143Zl + .Modal_footerContainer__1fxO- {\n        margin-top: 40px; } }\n\n/*\n  Footer Section\n*/\n.Modal_footerContainer__1fxO- {\n  display: flex;\n  flex-direction: column;\n  width: 100%; }\n  @media screen and (min-width: 576px) {\n    .Modal_footerContainer__1fxO- {\n      flex-direction: row; } }\n\n.Modal_footerElement1__3_I_w {\n  flex: 0; }\n\n.Modal_footer2and3Container__2YwV1 {\n  flex: 1;\n  display: flex;\n  justify-content: flex-end;\n  flex-direction: column; }\n  @media screen and (min-width: 576px) {\n    .Modal_footer2and3Container__2YwV1 {\n      flex-direction: row; } }\n\n.Modal_footerElement2and3__2hc7M {\n  margin-top: 16px; }\n  @media screen and (min-width: 576px) {\n    .Modal_footerElement2and3__2hc7M {\n      margin-top: 0;\n      margin-left: 16px; } }\n";
var styles$b = {"overlay":"Modal_overlay__2hRy4","slideUp":"Modal_slideUp__3mKs6","slideup":"Modal_slideup__3fNty","slideDown":"Modal_slideDown__TKAh1","slidedown":"Modal_slidedown__1aVT8","commonModalStyles":"Modal_commonModalStyles__1kPRh","headerContainer":"Modal_headerContainer__QPV60","footerContainer":"Modal_footerContainer__1fxO-","bodyContainer":"Modal_bodyContainer__143Zl","modalLarge":"Modal_modalLarge__3MCf_","modalMedium":"Modal_modalMedium__129Iu","modalSmall":"Modal_modalSmall__2j5Eu","footer2and3Container":"Modal_footer2and3Container__2YwV1","footerElement2and3":"Modal_footerElement2and3__2hc7M","headers":"Modal_headers__1juvz","modalCloseButton":"Modal_modalCloseButton__xOz--","modalCloseIcon":"Modal_modalCloseIcon__3Wy-Z","footerElement1":"Modal_footerElement1__3_I_w"};
styleInject(css_248z$b);

var Modal = function (_a) {
    var _b, _c;
    var children = _a.children, _d = _a.dataTestId, dataTestId = _d === void 0 ? 'StyleGuideModal' : _d, _e = _a.elementSize, elementSize = _e === void 0 ? Size.M : _e, _f = _a.footerClasses, footerClasses = _f === void 0 ? '' : _f, footerElement1 = _a.footerElement1, footerElement2 = _a.footerElement2, footerElement3 = _a.footerElement3, _g = _a.footerElement1Classes, footerElement1Classes = _g === void 0 ? '' : _g, _h = _a.footerElement2Classes, footerElement2Classes = _h === void 0 ? '' : _h, _j = _a.footerElement3Classes, footerElement3Classes = _j === void 0 ? '' : _j, header = _a.header, _k = _a.headerClasses, headerClasses = _k === void 0 ? '' : _k, _l = _a.hide, hide = _l === void 0 ? function () { } : _l, _m = _a.isVisible, isVisible = _m === void 0 ? false : _m, _o = _a.modalClassName, modalClassName = _o === void 0 ? '' : _o, _p = _a.modalCloseButtonClasses, modalCloseButtonClasses = _p === void 0 ? '' : _p, _q = _a.modalCloseIconClasses, modalCloseIconClasses = _q === void 0 ? '' : _q, _r = _a.onRequestClose, onRequestClose = _r === void 0 ? function () { } : _r, subheader = _a.subheader, _s = _a.subheaderClasses, subheaderClasses = _s === void 0 ? '' : _s, subheaderComponent = _a.subheaderComponent, props = __rest(_a, ["children", "dataTestId", "elementSize", "footerClasses", "footerElement1", "footerElement2", "footerElement3", "footerElement1Classes", "footerElement2Classes", "footerElement3Classes", "header", "headerClasses", "hide", "isVisible", "modalClassName", "modalCloseButtonClasses", "modalCloseIconClasses", "onRequestClose", "subheader", "subheaderClasses", "subheaderComponent"]);
    var slideAnimation = isVisible ? styles$b.slideUp : styles$b.slideDown;
    var modalStyles = classnames(styles$b.commonModalStyles, (_b = {},
        _b[styles$b.modalLarge] = elementSize === Size.L,
        _b[styles$b.modalMedium] = elementSize === Size.M,
        _b[styles$b.modalSmall] = elementSize === Size.S || elementSize === Size.XS,
        _b), slideAnimation, modalClassName);
    var headerStyles = classnames('h3', headerClasses);
    var subheaderStyles = classnames('p0 n700', subheaderClasses);
    var closeButtonStyles = classnames(styles$b.modalCloseButton, modalCloseButtonClasses);
    var closeIconStyles = classnames('paddingLeft-small1', styles$b.modalCloseIcon, modalCloseIconClasses);
    var footerContainerStyles = classnames(footerClasses, (_c = {},
        _c[styles$b.footerContainer] = footerElement1 || footerElement2 || footerElement3,
        _c));
    var footerElement1Styles = classnames(styles$b.footerElement1, footerElement1Classes);
    var footerElement2Styles = classnames(styles$b.footerElement2and3, footerElement2Classes);
    var footerElement3Styles = classnames(styles$b.footerElement2and3, footerElement3Classes);
    return (React.createElement(ReactModal, __assign({ ariaHideApp: false, contentLabel: header, isOpen: isVisible, overlayClassName: styles$b.overlay, className: modalStyles, onRequestClose: onRequestClose, testId: dataTestId }, props),
        React.createElement("div", { className: styles$b.headerContainer, "data-testid": dataTestId + "-headerContainer" },
            React.createElement("div", { className: styles$b.headers },
                header && (React.createElement("h3", { className: headerStyles, "data-testid": dataTestId + "-header" }, header)),
                subheader && (React.createElement("p", { className: subheaderStyles, "data-testid": dataTestId + "-subheader" }, subheader)),
                subheaderComponent),
            React.createElement("button", { type: "button", className: closeButtonStyles, onClick: hide, "data-testid": dataTestId + "-close" },
                React.createElement(Icon, { name: "v2-close-icon", className: closeIconStyles }))),
        children && (React.createElement("div", { className: styles$b.bodyContainer, "data-testid": dataTestId + "-bodyContainer" }, children)),
        React.createElement("div", { className: footerContainerStyles, "data-testid": dataTestId + "-footerContainer" },
            React.createElement("div", { className: footerElement1Styles }, footerElement1),
            React.createElement("div", { className: styles$b.footer2and3Container },
                footerElement2 && React.createElement("div", { className: footerElement2Styles }, footerElement2),
                footerElement3 && React.createElement("div", { className: footerElement3Styles }, footerElement3)))));
};
var Modal$1 = memo(Modal);

/**
 * This is the default operation on how we want to reduce on.
 * We offer an inversion of control if needed, but the default should suffice.
 * @param value
 * @returns {boolean}
 */
var defaultFunc = function (value) { return typeof value === 'boolean'; };
/**
 * This should be used with classnames as it returns an object of classnames with a boolean true so
 * 'classnames' package can consume them.
 * TODO: pass flag to circumvent the key/value association and just return what want.
 *
 * @param attrs
 * @param styles
 * @param fn
 * @returns {{
 *   myClassone: true,
 *   myClasstwo: true
 * }}
 */
var useWithStyles = (function (attrs, styles, fn) {
    if (attrs === void 0) { attrs = {}; }
    if (styles === void 0) { styles = {}; }
    if (fn === void 0) { fn = defaultFunc; }
    var _a = __read(useState(__assign({}, styles)), 2), newStyles = _a[0], setNewStyles = _a[1];
    useEffect(function () {
        var validStyles = Object.entries(attrs)
            .filter(function (_a) {
            var _b = __read(_a, 2), v = _b[1];
            return Boolean(v);
        })
            .reduce(function (accum, _a) {
            var _b;
            var _c = __read(_a, 2), k = _c[0], v = _c[1];
            return (__assign(__assign({}, accum), (fn(v) ? (_b = {}, _b[styles[k]] = v, _b) : {})));
        }, {});
        setNewStyles(validStyles);
    }, []);
    return newStyles;
});

var css_248z$c = "@use \"sass:map\";\n/* Mobile first, so mobile doesn't have a breakpoint, it starts at 0px; */\n/*  mobile grid */\n/*  tablet grid */\n/*  desktop grid */\n/*  Maps */\n/*  Mixins */\n/*  Styles for .col property are declared separately from .col-xx-xx classes */\n/* Use this to declare custom gutters in your Sass file */\n/*  Use this to declare default gutters in your Sass file */\n@use \"sass:map\";\n.Panel_panelContainer__1AteP {\n  background-color: #fff;\n  border-radius: 4px;\n  box-shadow: 0 8px 24px 4px rgba(38, 55, 70, 0.06); }\n\n.Panel_noShadow__1wRUY {\n  box-shadow: none; }\n\n.Panel_lowShadow__1SGq0 {\n  box-shadow: 0 1px 16px 0 rgba(38, 55, 70, 0.06); }\n\n.Panel_mediumShadow__2BMHE {\n  box-shadow: 0 8px 24px 4px rgba(38, 55, 70, 0.06); }\n\n.Panel_heavyShadow__1PYyA {\n  box-shadow: 0 16px 36px 8px rgba(38, 55, 70, 0.06); }\n\n.Panel_noBorderRadius__iLHqN {\n  border-radius: 0; }\n\n.Panel_smallBorderRadius__ITbzD {\n  border-radius: 2px; }\n\n.Panel_mediumBorderRadius__3AzsL {\n  border-radius: 4px; }\n\n.Panel_largeBorderRadius__YdS9f {\n  border-radius: 8px; }\n";
var styles$c = {"panelContainer":"Panel_panelContainer__1AteP","noShadow":"Panel_noShadow__1wRUY","lowShadow":"Panel_lowShadow__1SGq0","mediumShadow":"Panel_mediumShadow__2BMHE","heavyShadow":"Panel_heavyShadow__1PYyA","noBorderRadius":"Panel_noBorderRadius__iLHqN","smallBorderRadius":"Panel_smallBorderRadius__ITbzD","mediumBorderRadius":"Panel_mediumBorderRadius__3AzsL","largeBorderRadius":"Panel_largeBorderRadius__YdS9f"};
styleInject(css_248z$c);

var Panel = function (props) {
    var children = props.children, _a = props.className, className = _a === void 0 ? '' : _a, _b = props.dataTestId, dataTestId = _b === void 0 ? 'StyleGuidePanel' : _b;
    var panelClasses = classnames(styles$c.panelContainer, useWithStyles(props, styles$c), className);
    if (!children)
        return null;
    return (React.createElement("section", { "data-testid": dataTestId, className: panelClasses }, children));
};

var css_248z$d = "/* stylelint-disable no-descending-specificity */\n/* SPACING SCSS */\n@use \"sass:map\";\n/* Mobile first, so mobile doesn't have a breakpoint, it starts at 0px; */\n/*  mobile grid */\n/*  tablet grid */\n/*  desktop grid */\n/*  Maps */\n/*  Mixins */\n/*  Styles for .col property are declared separately from .col-xx-xx classes */\n/* Use this to declare custom gutters in your Sass file */\n/*  Use this to declare default gutters in your Sass file */\n/**********************************************************\n\nHelpers for applying margins/padding\n\n**********************************************************/\n/*\n  A function to get spacing value given the size key and viewport.\n\n  Usage:\n\n  @import 'src/styles/global_styles/spacing';\n\n  .someClass {\n    margin-right: spacing-value(small2, 'd');\n  }\n\n  ===> Output\n\n  .someClass {\n    margin-right: 32px;\n  }\n*/\n/*\n  Generate custom padding/margin with some given values.\n\n  The general idea here is to move away from hardcoding pixel values. Since\n  the design system is using a base unit of 8px, values should be a multiple\n  of the base unit.\n\n  This mixin will take in a property name and some values. These values should be a\n  multiplier of the desired pixel value.\n\n  However, if there is some need to use pixel values, this mixin can handle it.\n\n  Usage:\n\n  @import 'src/styles/global_styles/spacing';\n\n  .someClass {\n    @include spacing(margin, 8);\n    @include spacing(padding-right, 2);\n    @include spacing(padding, 12px 2.5);\n    @include spacing(margin-bottom, 3 !important);\n  }\n\n  ===> Output\n\n  .someClass {\n    margin: 64px;\n    padding-right: 16px;\n    padding: 12px 20px;\n    margin-bottom: 24px !important;\n  }\n*/\n.PlainModal_overlay__1QDAa {\n  overflow: hidden;\n  position: fixed;\n  z-index: 1990;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.3); }\n  .PlainModal_overlay__1QDAa.PlainModal_withMobilePadding__397yz {\n    padding: 16px; }\n    @media screen and (min-width: 576px) {\n      .PlainModal_overlay__1QDAa.PlainModal_withMobilePadding__397yz {\n        padding: inherit; } }\n  @media screen and (min-width: 576px) {\n    .PlainModal_overlay__1QDAa {\n      padding: 24px; } }\n\n.PlainModal_slideUp__3Sz0- {\n  animation: PlainModal_slideup__1IKh5 0.2s ease-in-out; }\n\n.PlainModal_slideDown__2rv72 {\n  animation: PlainModal_slidedown__1hKiP 0.2s linear; }\n\n@keyframes PlainModal_slideup__1IKh5 {\n  0% {\n    transform: translateY(100%); }\n  100% {\n    transform: translateY(0); } }\n\n@keyframes PlainModal_slidedown__1hKiP {\n  0% {\n    transform: translateY(0); }\n  100% {\n    transform: translateY(100%); } }\n\n/**\n  Modal\n*/\n.PlainModal_commonModalStyles__TTrA2 {\n  position: relative;\n  z-index: 1;\n  outline: none;\n  display: flex;\n  overflow: hidden;\n  height: 100%;\n  max-height: 100%;\n  width: 100%;\n  padding: 32px;\n  background-color: #fff; }\n  .PlainModal_commonModalStyles__TTrA2 .PlainModal_modalCloseButton__1KKWY {\n    top: 32px;\n    right: 32px; }\n  @media screen and (min-width: 576px) {\n    .PlainModal_commonModalStyles__TTrA2 {\n      height: auto;\n      border-radius: 4px; }\n      .PlainModal_commonModalStyles__TTrA2.PlainModal_slideUp__3Sz0- {\n        animation: none; }\n      .PlainModal_commonModalStyles__TTrA2.PlainModal_slideDown__2rv72 {\n        animation: none; } }\n\n@media screen and (min-width: 576px) {\n  .PlainModal_modalLarge__3xb2i {\n    max-width: 640px;\n    padding: 40px; }\n    .PlainModal_modalLarge__3xb2i .PlainModal_modalCloseButton__1KKWY {\n      top: 40px;\n      right: 40px; } }\n\n@media screen and (min-width: 992px) {\n  .PlainModal_modalLarge__3xb2i {\n    max-width: 880px;\n    padding: 48px; }\n    .PlainModal_modalLarge__3xb2i .PlainModal_modalCloseButton__1KKWY {\n      top: 48px;\n      right: 48px; } }\n\n@media screen and (min-width: 576px) {\n  .PlainModal_modalMedium__2mp5a {\n    max-width: 640px;\n    padding: 40px; }\n    .PlainModal_modalMedium__2mp5a .PlainModal_modalCloseButton__1KKWY {\n      top: 40px;\n      right: 40px; } }\n\n@media screen and (min-width: 576px) {\n  .PlainModal_modalSmall__1UUij {\n    max-width: 375px; } }\n\n/*\n  Close Button\n*/\n.PlainModal_modalCloseButton__1KKWY {\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 1;\n  align-self: flex-start;\n  appearance: none;\n  padding: 0 0 8px 8px;\n  background-color: transparent;\n  border: none;\n  margin: 0; }\n  .PlainModal_modalCloseButton__1KKWY:focus, .PlainModal_modalCloseButton__1KKWY:active {\n    outline: none; }\n  @media (hover: hover) {\n    .PlainModal_modalCloseButton__1KKWY:hover {\n      cursor: pointer; } }\n\n.PlainModal_modalCloseIcon__3wLDP {\n  font-size: 18px;\n  color: #ccd4dd; }\n  @media (hover: hover) {\n    .PlainModal_modalCloseIcon__3wLDP:hover {\n      color: #6d7d8c; } }\n\n/*\n  Children Container\n*/\n.PlainModal_childrenContainer__1d7id {\n  flex: 1;\n  overflow: auto;\n  padding-bottom: 2px; }\n";
var styles$d = {"overlay":"PlainModal_overlay__1QDAa","withMobilePadding":"PlainModal_withMobilePadding__397yz","slideUp":"PlainModal_slideUp__3Sz0-","slideup":"PlainModal_slideup__1IKh5","slideDown":"PlainModal_slideDown__2rv72","slidedown":"PlainModal_slidedown__1hKiP","commonModalStyles":"PlainModal_commonModalStyles__TTrA2","modalCloseButton":"PlainModal_modalCloseButton__1KKWY","modalLarge":"PlainModal_modalLarge__3xb2i","modalMedium":"PlainModal_modalMedium__2mp5a","modalSmall":"PlainModal_modalSmall__1UUij","modalCloseIcon":"PlainModal_modalCloseIcon__3wLDP","childrenContainer":"PlainModal_childrenContainer__1d7id"};
styleInject(css_248z$d);

var PlainModal = function (_a) {
    var _b, _c;
    var children = _a.children, _d = _a.dataTestId, dataTestId = _d === void 0 ? 'StyleGuidePlainModal' : _d, _e = _a.elementSize, elementSize = _e === void 0 ? Size.M : _e, _f = _a.hide, hide = _f === void 0 ? function () { } : _f, _g = _a.isVisible, isVisible = _g === void 0 ? false : _g, _h = _a.modalClassName, modalClassName = _h === void 0 ? '' : _h, _j = _a.modalCloseButtonClasses, modalCloseButtonClasses = _j === void 0 ? '' : _j, _k = _a.modalCloseIconClasses, modalCloseIconClasses = _k === void 0 ? '' : _k, _l = _a.onRequestClose, onRequestClose = _l === void 0 ? function () { } : _l, _m = _a.withMobilePadding, withMobilePadding = _m === void 0 ? false : _m, props = __rest(_a, ["children", "dataTestId", "elementSize", "hide", "isVisible", "modalClassName", "modalCloseButtonClasses", "modalCloseIconClasses", "onRequestClose", "withMobilePadding"]);
    var slideAnimation = isVisible ? styles$d.slideUp : styles$d.slideDown;
    var overlayStyles = classnames(styles$d.overlay, (_b = {},
        _b[styles$d.withMobilePadding] = withMobilePadding,
        _b));
    var modalStyles = classnames(styles$d.commonModalStyles, (_c = {},
        _c[styles$d.modalLarge] = elementSize === Size.L,
        _c[styles$d.modalMedium] = elementSize === Size.M,
        _c[styles$d.modalSmall] = elementSize === Size.S || elementSize === Size.XS,
        _c), slideAnimation, modalClassName);
    var closeButtonStyles = classnames(styles$d.modalCloseButton, modalCloseButtonClasses);
    var closeIconStyles = classnames(styles$d.modalCloseIcon, modalCloseIconClasses);
    return (React.createElement(ReactModal, __assign({ ariaHideApp: false, isOpen: isVisible, onRequestClose: onRequestClose, overlayClassName: overlayStyles, className: modalStyles, testId: dataTestId }, props),
        React.createElement("button", { type: "button", className: closeButtonStyles, onClick: hide, "data-testid": dataTestId + "-close" },
            React.createElement(Icon, { name: "v2-close-icon", className: closeIconStyles })),
        React.createElement("div", { className: styles$d.childrenContainer, "data-testid": dataTestId + "-childrenContainer" }, children)));
};
var PlainModal$1 = memo(PlainModal);

var css_248z$e = "@use \"sass:map\";\n/* Mobile first, so mobile doesn't have a breakpoint, it starts at 0px; */\n/*  mobile grid */\n/*  tablet grid */\n/*  desktop grid */\n/*  Maps */\n/*  Mixins */\n/*  Styles for .col property are declared separately from .col-xx-xx classes */\n/* Use this to declare custom gutters in your Sass file */\n/*  Use this to declare default gutters in your Sass file */\n/* SPACING SCSS */\n@use \"sass:map\";\n/* Mobile first, so mobile doesn't have a breakpoint, it starts at 0px; */\n/*  mobile grid */\n/*  tablet grid */\n/*  desktop grid */\n/*  Maps */\n/*  Mixins */\n/*  Styles for .col property are declared separately from .col-xx-xx classes */\n/* Use this to declare custom gutters in your Sass file */\n/*  Use this to declare default gutters in your Sass file */\n/**********************************************************\n\nHelpers for applying margins/padding\n\n**********************************************************/\n/*\n  A function to get spacing value given the size key and viewport.\n\n  Usage:\n\n  @import 'src/styles/global_styles/spacing';\n\n  .someClass {\n    margin-right: spacing-value(small2, 'd');\n  }\n\n  ===> Output\n\n  .someClass {\n    margin-right: 32px;\n  }\n*/\n/*\n  Generate custom padding/margin with some given values.\n\n  The general idea here is to move away from hardcoding pixel values. Since\n  the design system is using a base unit of 8px, values should be a multiple\n  of the base unit.\n\n  This mixin will take in a property name and some values. These values should be a\n  multiplier of the desired pixel value.\n\n  However, if there is some need to use pixel values, this mixin can handle it.\n\n  Usage:\n\n  @import 'src/styles/global_styles/spacing';\n\n  .someClass {\n    @include spacing(margin, 8);\n    @include spacing(padding-right, 2);\n    @include spacing(padding, 12px 2.5);\n    @include spacing(margin-bottom, 3 !important);\n  }\n\n  ===> Output\n\n  .someClass {\n    margin: 64px;\n    padding-right: 16px;\n    padding: 12px 20px;\n    margin-bottom: 24px !important;\n  }\n*/\n.Radio_input__xSY-J {\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px; }\n\n.Radio_labelWrapper__1_CpG {\n  display: flex;\n  flex-wrap: nowrap; }\n  .Radio_labelWrapper__1_CpG.Radio_xsmall__2gRh1, .Radio_labelWrapper__1_CpG.Radio_small__2TITx, .Radio_labelWrapper__1_CpG.Radio_medium__3gUlS {\n    padding: 12px 0px; }\n  .Radio_labelWrapper__1_CpG.Radio_large__3GrHH {\n    padding: 12px 0px; }\n    @media screen and (min-width: 576px) {\n      .Radio_labelWrapper__1_CpG.Radio_large__3GrHH {\n        padding: 16px 0px; } }\n  .Radio_labelWrapper__1_CpG.Radio_disabled__1HZ9Y {\n    opacity: 0.3;\n    pointer-events: none; }\n  @media (hover: hover) {\n    .Radio_labelWrapper__1_CpG:hover {\n      cursor: pointer; }\n      .Radio_labelWrapper__1_CpG:hover .Radio_circle__1Yf7X {\n        border-color: #263746; }\n        .Radio_labelWrapper__1_CpG:hover .Radio_circle__1Yf7X.Radio_circleSelected__33tLK {\n          background-color: #32a4ee;\n          border-color: #32a4ee; } }\n  .Radio_labelWrapper__1_CpG .Radio_circle__1Yf7X {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 20px;\n    width: 20px;\n    border-radius: 50%;\n    border: 1px solid #ccd4dd;\n    margin-right: 14px; }\n    .Radio_labelWrapper__1_CpG .Radio_circle__1Yf7X.Radio_circleSelected__33tLK {\n      background-color: #0992e9;\n      border: 1px solid #0992e9; }\n    .Radio_labelWrapper__1_CpG .Radio_circle__1Yf7X .Radio_innerDot__2r2xm {\n      width: 4px;\n      height: 4px;\n      background-color: #fff;\n      border-radius: 50%;\n      border: 1px solid #fff; }\n  .Radio_labelWrapper__1_CpG .Radio_label__2TQcN {\n    font-size: 16px;\n    font-weight: 400;\n    letter-spacing: -0.15px;\n    line-height: 1.5;\n    color: #263746 !important; }\n    .Radio_labelWrapper__1_CpG .Radio_label__2TQcN.Radio_bold__2QueS {\n      font-weight: 700; }\n\n.Radio_childWrapper__14pkC {\n  margin-left: 34px; }\n";
var styles$e = {"input":"Radio_input__xSY-J","labelWrapper":"Radio_labelWrapper__1_CpG","xsmall":"Radio_xsmall__2gRh1","small":"Radio_small__2TITx","medium":"Radio_medium__3gUlS","large":"Radio_large__3GrHH","disabled":"Radio_disabled__1HZ9Y","circle":"Radio_circle__1Yf7X","circleSelected":"Radio_circleSelected__33tLK","innerDot":"Radio_innerDot__2r2xm","label":"Radio_label__2TQcN","bold":"Radio_bold__2QueS","childWrapper":"Radio_childWrapper__14pkC"};
styleInject(css_248z$e);

var Circle = function (_a) {
    var _b;
    var selected = _a.selected;
    var circleStyles = classnames(styles$e.circle, (_b = {},
        _b[styles$e.circleSelected] = selected,
        _b));
    return React.createElement("div", { className: circleStyles }, selected && React.createElement("div", { className: styles$e.innerDot }));
};

var inputIdCounter$2 = 0;
var Radio = function (_a) {
    var _b, _c;
    var children = _a.children, label = _a.label, _d = _a.selected, selected = _d === void 0 ? false : _d, radioValue = _a.value, disabled = _a.disabled, _e = _a.onChange, onChange = _e === void 0 ? function () { } : _e, _f = _a.enableDeselect, enableDeselect = _f === void 0 ? false : _f, _g = _a.wrapperClass, wrapperClass = _g === void 0 ? '' : _g, _h = _a.labelClass, labelClass = _h === void 0 ? '' : _h, _j = _a.elementSize, elementSize = _j === void 0 ? Size.M : _j, _k = _a.boldLabel, boldLabel = _k === void 0 ? false : _k, _l = _a.id, id = _l === void 0 ? '' : _l, _m = _a.dataTestId, dataTestId = _m === void 0 ? 'StyleGuideRadio' : _m, rest = __rest(_a, ["children", "label", "selected", "value", "disabled", "onChange", "enableDeselect", "wrapperClass", "labelClass", "elementSize", "boldLabel", "id", "dataTestId"]);
    var _o = __read(useState(id), 2), inputId = _o[0], setInputId = _o[1];
    useEffect(function () {
        if (!id) {
            setInputId("Radio-" + inputIdCounter$2);
            inputIdCounter$2 += 1;
        }
    }, []);
    var labelWrapperStyles = classnames(styles$e.labelWrapper, styles$e[elementSize], wrapperClass, (_b = {},
        _b[styles$e.disabled] = disabled,
        _b));
    var labelStyles = classnames(styles$e.label, labelClass, (_c = {},
        _c[styles$e.bold] = boldLabel,
        _c));
    var onClick = function (rValue) { return function (event) {
        var currentTarget = event.target;
        var checked = currentTarget.checked;
        if (enableDeselect && selected) {
            onChange(null); // deselect
        }
        else {
            onChange(checked ? rValue : null);
        }
    }; };
    return (React.createElement("div", { "data-testid": dataTestId },
        React.createElement("label", { htmlFor: inputId, className: labelWrapperStyles },
            React.createElement("div", null,
                React.createElement("input", __assign({ id: inputId, type: "radio", disabled: disabled, defaultChecked: selected, onClick: onClick(radioValue), value: radioValue, className: styles$e.input }, rest)),
                React.createElement(Circle, { selected: selected })),
            React.createElement("div", null,
                React.createElement("span", { className: labelStyles }, label))),
        React.createElement("div", { className: styles$e.childWrapper }, children)));
};

var RadioGroup = function (_a) {
    var label = _a.label, labelComponent = _a.labelComponent, dangerouslySetLabel = _a.dangerouslySetLabel, children = _a.children, value = _a.value, onChange = _a.onChange, _b = _a.disableSort, disableSort = _b === void 0 ? true : _b, _c = _a.disableGrouping, disableGrouping = _c === void 0 ? true : _c, _d = _a.enableDeselect, enableDeselect = _d === void 0 ? false : _d, _e = _a.containerClassName, containerClassName = _e === void 0 ? '' : _e, _f = _a.columnClassName, columnClassName = _f === void 0 ? '' : _f, _g = _a.rowClassName, rowClassName = _g === void 0 ? '' : _g, _h = _a.elementSize, elementSize = _h === void 0 ? Size.M : _h, _j = _a.dataTestId, dataTestId = _j === void 0 ? 'StyleGuideRadioGroup' : _j;
    // We want to pass down extra props to the children (Radio)
    var childrenWithExtras = Children.map(children, function (child) {
        return cloneElement(child, {
            selected: value === child.props.value,
            onChange: onChange,
            elementSize: elementSize,
            enableDeselect: enableDeselect,
        });
    });
    // Group the children if necessary. See the utils
    var _k = useGetGroupedChildren({
        children: childrenWithExtras,
        disableSort: disableSort,
        disableGrouping: disableGrouping,
    }), groupedChildren = _k.groupedChildren, columnProps = _k.columnProps;
    return (React.createElement("div", { className: containerClassName, "data-testid": dataTestId },
        React.createElement(Label, { elementSize: elementSize, label: label, labelComponent: labelComponent, dangerouslySetLabel: dangerouslySetLabel }),
        React.createElement(Grid.FullWidth, null,
            React.createElement(Grid.Row, { classes: rowClassName }, groupedChildren.map(function (group, i) { return (
            // eslint-disable-next-line react/no-array-index-key
            React.createElement(Grid.Column, __assign({ classes: columnClassName }, columnProps, { key: i }), group)); })))));
};
var RadioGroup$1 = memo(RadioGroup);
/**
  RadioGroup

  This group is used with Radio. If the options count exceed a certain limit,
  the options will be displayed in multiple columns instead of a single column. Also,
  the options will be sorted alphabetically when they are broken down into columns.
  Props are provided to override these default settings.

  Note:
  Radio must be a direct child of RadioGroup for this to work, or
  just take extra care if you're using a custom checkbox component.

  Props:
  label - A label of type string to render.
  labelComponent - A custom component to render for the label.
  dangerouslySetLabel - A string to dangerously set its inner html.
  value - Value of the selected radio
  onChange - Function to when selecting. First argument is the selected value.
  disableSort - Disable sorting of list when breaking into multiple columns.
  disableGrouping - Disable breaking into multiple columns. Show options in a single column regardless of options count.
  size - Form size. Affects container label and list spacing

  ---------

  General Usage:

  import { Radio, RadioGroup } from 'components/Elements/Radio';

  ...

  const [radio, setRadio] = useState(1);
  const onChange = (selectedValue) => {
    setRadio(selectedValue);
  };

  return (
    <RadioGroup
      label="An Optional Label"
      value={radio}
      onChange={onChange}
      containerClassName={styles.container}
    >
      <Radio value={1} label="Number 1" />
      <Radio value={2} label="Number 2" />
      <Radio value={3} label="Number 3" boldLabel />
      <Radio value={4} label="Number 4">
        <p className="caption">Some custom component to show below the label</p>
      </Radio>
    </RadioGroup>
  );
*/

/**
 * lodash 3.0.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject$4(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

var lodash_isobject = isObject$4;

// react-select expects the value to be an object or an array of objects
var prepareValue = function (value, options) {
    var _a;
    if (value && !lodash_isobject(value)) {
        // @ts-ignore
        if (((_a = options[0]) !== null && _a !== void 0 ? _a : {}).options) {
            return (options
                // @ts-ignore
                .map(function (group) { return group.options; })
                .flat()
                .find(function (o) { return o.value === value; }));
        }
        // @ts-ignore
        return options === null || options === void 0 ? void 0 : options.find(function (o) { return o.value === value; });
    }
    return value;
};

var css_248z$f = "/* SPACING SCSS */\n@use \"sass:map\";\n/* Mobile first, so mobile doesn't have a breakpoint, it starts at 0px; */\n/*  mobile grid */\n/*  tablet grid */\n/*  desktop grid */\n/*  Maps */\n/*  Mixins */\n/*  Styles for .col property are declared separately from .col-xx-xx classes */\n/* Use this to declare custom gutters in your Sass file */\n/*  Use this to declare default gutters in your Sass file */\n/**********************************************************\n\nHelpers for applying margins/padding\n\n**********************************************************/\n/*\n  A function to get spacing value given the size key and viewport.\n\n  Usage:\n\n  @import 'src/styles/global_styles/spacing';\n\n  .someClass {\n    margin-right: spacing-value(small2, 'd');\n  }\n\n  ===> Output\n\n  .someClass {\n    margin-right: 32px;\n  }\n*/\n/*\n  Generate custom padding/margin with some given values.\n\n  The general idea here is to move away from hardcoding pixel values. Since\n  the design system is using a base unit of 8px, values should be a multiple\n  of the base unit.\n\n  This mixin will take in a property name and some values. These values should be a\n  multiplier of the desired pixel value.\n\n  However, if there is some need to use pixel values, this mixin can handle it.\n\n  Usage:\n\n  @import 'src/styles/global_styles/spacing';\n\n  .someClass {\n    @include spacing(margin, 8);\n    @include spacing(padding-right, 2);\n    @include spacing(padding, 12px 2.5);\n    @include spacing(margin-bottom, 3 !important);\n  }\n\n  ===> Output\n\n  .someClass {\n    margin: 64px;\n    padding-right: 16px;\n    padding: 12px 20px;\n    margin-bottom: 24px !important;\n  }\n*/\n.SelectField_htSelect__3zz9G.SelectField_xsmall__3mCeT .react-select__placeholder, .SelectField_htSelect__3zz9G.SelectField_xsmall__3mCeT .react-select__single-value, .SelectField_htSelect__3zz9G.SelectField_xsmall__3mCeT .react-select__input input, .SelectField_htSelect__3zz9G.SelectField_xsmall__3mCeT .SelectField_htSelectOption__3Fgq0 {\n  font-family: \"indivisible-variable\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  letter-spacing: -0.12px;\n  line-height: 1.429; }\n\n.SelectField_htSelect__3zz9G.SelectField_small__3VSeW .react-select__placeholder, .SelectField_htSelect__3zz9G.SelectField_small__3VSeW .react-select__single-value, .SelectField_htSelect__3zz9G.SelectField_small__3VSeW .react-select__input input, .SelectField_htSelect__3zz9G.SelectField_small__3VSeW .SelectField_htSelectOption__3Fgq0 {\n  font-family: \"indivisible-variable\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  letter-spacing: -0.15px;\n  line-height: 1.5; }\n\n.SelectField_htSelect__3zz9G .react-select__value-container, .SelectField_htSelect__3zz9G .react-select__placeholder, .SelectField_htSelect__3zz9G .react-select__single-value, .SelectField_htSelect__3zz9G .react-select__input input, .SelectField_htSelect__3zz9G .SelectField_htSelectOption__3Fgq0, .SelectField_htSelectEmpty__1bCKY {\n  font-family: \"indivisible-variable\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  letter-spacing: -0.15px;\n  line-height: 1.5; }\n\n.SelectField_htSelect__3zz9G.SelectField_large__KLMmR .react-select__placeholder, .SelectField_htSelect__3zz9G.SelectField_large__KLMmR .react-select__single-value, .SelectField_htSelect__3zz9G.SelectField_large__KLMmR .react-select__input input, .SelectField_htSelect__3zz9G.SelectField_large__KLMmR .SelectField_htSelectOption__3Fgq0 {\n  font-family: \"indivisible-variable\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-weight: 400;\n  font-size: 20px;\n  letter-spacing: -0.25px;\n  line-height: 1.4; }\n\n/******************\n  SelectField\n*******************/\n.SelectField_innerSelectWrapper__2Ff58 {\n  position: relative; }\n\n.SelectField_hint__KwnkJ {\n  margin-bottom: 4px; }\n\n.SelectField_htSelect__3zz9G {\n  /*\n    Custom States\n  */\n  /*\n    X-Small size's styles and overrides\n  */\n  /*\n    Small size's styles and overrides\n  */\n  /*\n    Large size's styles and overrides\n  */\n  /******************\n    Option\n  *******************/ }\n  .SelectField_htSelect__3zz9G .react-select__control {\n    border-radius: 2px;\n    border: solid 1px #ccd4dd;\n    box-shadow: none;\n    padding: 12px 16px;\n    cursor: pointer; }\n    .SelectField_htSelect__3zz9G .react-select__control:hover {\n      border-color: #263746; }\n    .SelectField_htSelect__3zz9G .react-select__control--is-focused, .SelectField_htSelect__3zz9G .react-select__control--is-focused:hover, .SelectField_htSelect__3zz9G .react-select__control--menu-is-open, .SelectField_htSelect__3zz9G .react-select__control--menu-is-open:hover {\n      border-color: #0992e9; }\n  .SelectField_htSelect__3zz9G .react-select__value-container {\n    padding: 2px 0px; }\n    .SelectField_htSelect__3zz9G .react-select__value-container div:last-child {\n      margin: 0;\n      padding: 0;\n      overflow: auto;\n      line-height: 0; }\n  .SelectField_htSelect__3zz9G .react-select__placeholder, .SelectField_htSelect__3zz9G .react-select__single-value {\n    color: #263746;\n    margin: 0;\n    overflow: hidden; }\n    .SelectField_htSelect__3zz9G .react-select__placeholder + div, .SelectField_htSelect__3zz9G .react-select__single-value + div {\n      padding: 0;\n      margin: 0;\n      line-height: 0; }\n  .SelectField_htSelect__3zz9G .react-select__indicator-separator {\n    width: 0; }\n  .SelectField_htSelect__3zz9G .react-select__clear-indicator {\n    padding: 0px 8px 0px 0px; }\n  .SelectField_htSelect__3zz9G .react-select__menu {\n    margin-top: 4px;\n    margin-bottom: 4px;\n    background: #fff;\n    border-radius: 2px;\n    box-shadow: 0 1px 16px 0 rgba(38, 55, 70, 0.06); }\n  .SelectField_htSelect__3zz9G .react-select__menu-list {\n    padding: 8px 0px;\n    max-height: 228px; }\n    .SelectField_htSelect__3zz9G .react-select__menu-list > div.selected {\n      color: #263746;\n      background-color: #f4f8fc; }\n    .SelectField_htSelect__3zz9G .react-select__menu-list > div.customSelection:first-child {\n      border-bottom: 1px solid #edf1f7; }\n  .SelectField_htSelect__3zz9G.SelectField_searchable__3ic_a .react-select__control {\n    padding: 8px 16px; }\n  .SelectField_htSelect__3zz9G.SelectField_invalid__2hXyE .react-select__control {\n    border-color: #ff726c; }\n  .SelectField_htSelect__3zz9G.SelectField_xsmall__3mCeT .react-select__control {\n    min-height: 32px;\n    padding: 5px 12px; }\n  .SelectField_htSelect__3zz9G.SelectField_xsmall__3mCeT .react-select__value-container {\n    padding: 0; }\n  .SelectField_htSelect__3zz9G.SelectField_xsmall__3mCeT.SelectField_searchable__3ic_a .react-select__control {\n    padding: 5px 12px; }\n  .SelectField_htSelect__3zz9G.SelectField_small__3VSeW .react-select__control {\n    padding: 8px 12px; }\n  .SelectField_htSelect__3zz9G.SelectField_small__3VSeW .react-select__value-container {\n    padding: 0; }\n  .SelectField_htSelect__3zz9G.SelectField_small__3VSeW.SelectField_searchable__3ic_a .react-select__control {\n    padding: 4px 12px; }\n  .SelectField_htSelect__3zz9G.SelectField_large__KLMmR .react-select__control {\n    padding: 16px 20px; }\n  .SelectField_htSelect__3zz9G.SelectField_large__KLMmR.SelectField_searchable__3ic_a .react-select__control {\n    padding: 12px 20px; }\n  .SelectField_htSelect__3zz9G .SelectField_htSelectOption__3Fgq0 {\n    padding: 12px 16px;\n    cursor: pointer; }\n  .SelectField_htSelect__3zz9G.SelectField_large__KLMmR .SelectField_htSelectOption__3Fgq0 {\n    padding: 16px 20px; }\n\n/******************\n  Arrow\n*******************/\n.SelectField_htSelectArrow__biGjf {\n  font-size: 16px; }\n  .SelectField_htSelectArrow__biGjf.SelectField_focused__288rm {\n    transform: rotateX(180deg); }\n\n/******************\n  Empty\n*******************/\n.SelectField_htSelectEmpty__1bCKY {\n  padding: 12px 16px;\n  text-align: center; }\n";
var styles$f = {"htSelect":"SelectField_htSelect__3zz9G","xsmall":"SelectField_xsmall__3mCeT","htSelectOption":"SelectField_htSelectOption__3Fgq0","small":"SelectField_small__3VSeW","htSelectEmpty":"SelectField_htSelectEmpty__1bCKY","large":"SelectField_large__KLMmR","innerSelectWrapper":"SelectField_innerSelectWrapper__2Ff58","hint":"SelectField_hint__KwnkJ","searchable":"SelectField_searchable__3ic_a","invalid":"SelectField_invalid__2hXyE","htSelectArrow":"SelectField_htSelectArrow__biGjf","focused":"SelectField_focused__288rm"};
styleInject(css_248z$f);

var SelectEmpty = function (_a) {
    var _b = (_a === void 0 ? {} : _a).innerProps, innerProps = _b === void 0 ? {} : _b;
    // @ts-ignore
    var _c = innerProps.emptyText, emptyText = _c === void 0 ? 'No Results' : _c;
    return (React.createElement("div", __assign({}, innerProps, { className: styles$f.htSelectEmpty }), emptyText));
};

var removeHTMLTags = function (elem) {
    var _a, _b;
    // eslint-disable-next-line no-underscore-dangle
    var str = (_b = (_a = elem.props) === null || _a === void 0 ? void 0 : _a.dangerouslySetInnerHTML.__html) !== null && _b !== void 0 ? _b : '';
    return str.replace(/<(\w+)>(\w*)<\/\1>/g, '$2');
};
var SelectOption = function (_a) {
    var innerProps = _a.innerProps, isSelected = _a.isSelected, isFocused = _a.isFocused, children = _a.children, selectProps = _a.selectProps;
    var showCustomStyle = Boolean(selectProps === null || selectProps === void 0 ? void 0 : selectProps.options.find(function (o) { return o.value === 0; })); // give a fallback
    return (React.createElement("div", __assign({ "data-testid": removeHTMLTags(children) }, innerProps, { className: classnames(styles$f.htSelectOption, {
            selected: isSelected || isFocused,
            customSelection: showCustomStyle,
        }) }), children));
};

var SelectArrow = function (_a) {
    var innerProps = _a.innerProps, selectProps = _a.selectProps;
    return (React.createElement(Icon, __assign({ name: "chevron" }, innerProps, { className: classnames(styles$f.htSelectArrow, { focused: selectProps === null || selectProps === void 0 ? void 0 : selectProps.menuIsOpen }) })));
};

var SelectFormattedLabel = function (_a, _b) {
    var _c = _a.label, label = _c === void 0 ? '' : _c;
    var _d = _b.inputValue, inputValue = _d === void 0 ? '' : _d;
    var highlighted = label && label.toString().replace(new RegExp(inputValue, 'gi'), function (h) { return "<strong>" + h + "</strong>"; });
    return React.createElement("span", { dangerouslySetInnerHTML: { __html: highlighted } });
};

var SelectField = function (_a) {
    var _b;
    var id = _a.id, groups = _a.groups, options = _a.options, invalid = _a.invalid, error = _a.error, label = _a.label, hint = _a.hint, className = _a.className, reactSelectClassName = _a.reactSelectClassName, _c = _a.elementSize, elementSize = _c === void 0 ? Size.M : _c, _d = _a.searchable, searchable = _d === void 0 ? false : _d, _e = _a.clearable, clearable = _e === void 0 ? false : _e, _f = _a.value, value = _f === void 0 ? { value: '', label: '' } : _f, _g = _a.onChange, onChange = _g === void 0 ? function () { } : _g, _h = _a.dataTestId, dataTestId = _h === void 0 ? 'StyleGuideSelectField' : _h, rest = __rest(_a, ["id", "groups", "options", "invalid", "error", "label", "hint", "className", "reactSelectClassName", "elementSize", "searchable", "clearable", "value", "onChange", "dataTestId"]);
    var fieldOptions = groups || options || [];
    var selectStyles = classnames(styles$f.htSelect, (_b = {}, _b[styles$f.invalid] = error || invalid, _b[styles$f.searchable] = searchable, _b), styles$f[elementSize], reactSelectClassName);
    var fieldValue = prepareValue(value, fieldOptions);
    return (React.createElement("div", { id: id, className: className },
        React.createElement(Label, { elementSize: elementSize, dangerouslySetLabel: label }),
        hint && React.createElement("p", { className: classnames('p2', styles$f.hint) }, hint),
        React.createElement("div", { className: styles$f.innerSelectWrapper, "data-testid": dataTestId },
            React.createElement(ReactSelect, __assign({}, rest, { onChange: onChange, value: fieldValue, isClearable: clearable, isSearchable: searchable, className: selectStyles, classNamePrefix: "react-select", components: {
                    Option: SelectOption,
                    DropdownIndicator: SelectArrow,
                    NoOptionsMessage: SelectEmpty,
                }, formatOptionLabel: SelectFormattedLabel, options: fieldOptions })),
            React.createElement(ErrorMessage, { error: error }))));
};

var css_248z$g = "/* SPACING SCSS */\n@use \"sass:map\";\n/* Mobile first, so mobile doesn't have a breakpoint, it starts at 0px; */\n/*  mobile grid */\n/*  tablet grid */\n/*  desktop grid */\n/*  Maps */\n/*  Mixins */\n/*  Styles for .col property are declared separately from .col-xx-xx classes */\n/* Use this to declare custom gutters in your Sass file */\n/*  Use this to declare default gutters in your Sass file */\n/**********************************************************\n\nHelpers for applying margins/padding\n\n**********************************************************/\n/*\n  A function to get spacing value given the size key and viewport.\n\n  Usage:\n\n  @import 'src/styles/global_styles/spacing';\n\n  .someClass {\n    margin-right: spacing-value(small2, 'd');\n  }\n\n  ===> Output\n\n  .someClass {\n    margin-right: 32px;\n  }\n*/\n/*\n  Generate custom padding/margin with some given values.\n\n  The general idea here is to move away from hardcoding pixel values. Since\n  the design system is using a base unit of 8px, values should be a multiple\n  of the base unit.\n\n  This mixin will take in a property name and some values. These values should be a\n  multiplier of the desired pixel value.\n\n  However, if there is some need to use pixel values, this mixin can handle it.\n\n  Usage:\n\n  @import 'src/styles/global_styles/spacing';\n\n  .someClass {\n    @include spacing(margin, 8);\n    @include spacing(padding-right, 2);\n    @include spacing(padding, 12px 2.5);\n    @include spacing(margin-bottom, 3 !important);\n  }\n\n  ===> Output\n\n  .someClass {\n    margin: 64px;\n    padding-right: 16px;\n    padding: 12px 20px;\n    margin-bottom: 24px !important;\n  }\n*/\n.TextArea_textarea__3ipkg {\n  resize: none;\n  outline: none;\n  overflow-y: hidden;\n  width: 100%;\n  border: 1px #ccd4dd solid;\n  border-radius: 2px;\n  margin: 0;\n  font-weight: 400; }\n  .TextArea_textarea__3ipkg.TextArea_xsmall__2xBGA {\n    padding: 7px 12px;\n    font-size: 14px;\n    letter-spacing: -0.12px;\n    line-height: 1.429; }\n  .TextArea_textarea__3ipkg.TextArea_small__3ouvK {\n    padding: 7px 12px;\n    font-size: 16px;\n    letter-spacing: -0.15px;\n    line-height: 1.5; }\n  .TextArea_textarea__3ipkg.TextArea_medium__2MWHF {\n    padding: 7px 12px;\n    font-size: 16px;\n    letter-spacing: -0.15px;\n    line-height: 1.5; }\n  .TextArea_textarea__3ipkg.TextArea_large__2qTMf {\n    padding: 13px 16px;\n    font-size: 20px;\n    letter-spacing: -0.25px;\n    line-height: 1.4; }\n  .TextArea_textarea__3ipkg.TextArea_withError__26WML {\n    border-color: #ff726c; }\n  @media (hover: hover) {\n    .TextArea_textarea__3ipkg:hover:hover {\n      border-color: #263746; } }\n  .TextArea_textarea__3ipkg:focus {\n    border-color: #32a4ee; }\n";
var styles$g = {"textarea":"TextArea_textarea__3ipkg","xsmall":"TextArea_xsmall__2xBGA","small":"TextArea_small__3ouvK","medium":"TextArea_medium__2MWHF","large":"TextArea_large__2qTMf","withError":"TextArea_withError__26WML"};
styleInject(css_248z$g);

var TextArea = function (_a) {
    var _b;
    var _c = _a.elementSize, elementSize = _c === void 0 ? Size.MEDIUM : _c, label = _a.label, labelComponent = _a.labelComponent, dangerouslySetLabel = _a.dangerouslySetLabel, error = _a.error, value = _a.value, _d = _a.onChange, onChange = _d === void 0 ? function () { } : _d, placeholder = _a.placeholder, _e = _a.containerClass, containerClass = _e === void 0 ? '' : _e, _f = _a.textareaClass, textareaClass = _f === void 0 ? '' : _f, _g = _a.dataTestId, dataTestId = _g === void 0 ? 'StyleGuideTextArea' : _g, _h = _a.rows, rows = _h === void 0 ? 3 : _h, rest = __rest(_a, ["elementSize", "label", "labelComponent", "dangerouslySetLabel", "error", "value", "onChange", "placeholder", "containerClass", "textareaClass", "dataTestId", "rows"]);
    var textareaRef = useRef(null);
    var initialAttributes = useRef({ offsetHeight: 0, borderWidth: 1 });
    var textareaIdRef = useRef("TextArea-" + Math.random());
    var textareaId = textareaIdRef.current;
    // Save textarea attributes that are needed for resizing
    useLayoutEffect(function () {
        var offsetHeight = textareaRef.current.offsetHeight;
        var borderWidthPixels = getComputedStyle(textareaRef.current).borderWidth;
        var borderWidth = parseInt(borderWidthPixels, 10);
        initialAttributes.current = { offsetHeight: offsetHeight, borderWidth: borderWidth };
    }, []);
    // This is where the resizing happens.
    useLayoutEffect(function () {
        var _a;
        var _b = initialAttributes.current, initialOffsetHeight = _b.offsetHeight, borderWidth = _b.borderWidth;
        var currentScrollHeight = (_a = textareaRef.current) === null || _a === void 0 ? void 0 : _a.scrollHeight;
        if (textareaRef && currentScrollHeight && currentScrollHeight > initialOffsetHeight) {
            /*
              Set the height to auto to reset the height.
              The user may remove text that'll delete a row.
            */
            var current = textareaRef.current;
            current.style.height = 'auto';
            var totalHeight = current.scrollHeight + borderWidth * 2;
            current.style.setProperty('height', totalHeight + "px");
        }
    }, [value]);
    // Styles
    var textAreaStyles = classnames(styles$g.textarea, (_b = {},
        _b[styles$g.xsmall] = elementSize === Size.XSMALL,
        _b[styles$g.small] = elementSize === Size.SMALL,
        _b[styles$g.medium] = elementSize === Size.MEDIUM,
        _b[styles$g.large] = elementSize === Size.LARGE,
        _b[styles$g.withError] = !!error,
        _b), textareaClass);
    return (React.createElement("div", { "data-testid": dataTestId, className: containerClass },
        React.createElement(Label, { label: label, labelComponent: labelComponent, dangerouslySetLabel: dangerouslySetLabel, elementSize: elementSize, inputId: textareaId }),
        React.createElement("textarea", __assign({ id: textareaId, rows: rows, ref: textareaRef, className: textAreaStyles, value: value, onChange: onChange, placeholder: placeholder }, rest)),
        React.createElement(ErrorMessage, { error: error })));
};
/*
  TextAreaV2

  Component to render textareas.

  Props:

  containerClass - A class to apply to the overall component.
  textareaClass - A class to apply to <textarea />
  size - The size theme for the input. 'medium' is the default.
  onChange - Function to call when the input changes.
  value - Value of the input.
  label - A label of type string to render.
  labelComponent - A custom component to render for the label.
  dangerouslySetLabel - A string to dangerously set its inner html.
  error - The message to display for the input.
  placeholder - A placeholder.
  rows - The number of rows to pass to the <textarea /> element

  Remaining props will be used for the textarea tag.

  --------

  Usage:

  import { TextAreaV2, FORM_SIZE } from 'src/HTKit';

  ...

  const [inputValue, setInputValue] = useState();

  const onChange = (e) => {
    setInputValue(e.target.value);
  }

  return (
    <TextAreaV2
      label="A happy label"
      size={FORM_SIZE.large}
      value={inputValue}
      onChange=(onChange)
    />
  );
*/

var TOAST_CONTAINER_ID = 'ht-toast-container';

var css_248z$h = "@use \"sass:map\";\n/* Mobile first, so mobile doesn't have a breakpoint, it starts at 0px; */\n/*  mobile grid */\n/*  tablet grid */\n/*  desktop grid */\n/*  Maps */\n/*  Mixins */\n/*  Styles for .col property are declared separately from .col-xx-xx classes */\n/* Use this to declare custom gutters in your Sass file */\n/*  Use this to declare default gutters in your Sass file */\n/* SPACING SCSS */\n@use \"sass:map\";\n/* Mobile first, so mobile doesn't have a breakpoint, it starts at 0px; */\n/*  mobile grid */\n/*  tablet grid */\n/*  desktop grid */\n/*  Maps */\n/*  Mixins */\n/*  Styles for .col property are declared separately from .col-xx-xx classes */\n/* Use this to declare custom gutters in your Sass file */\n/*  Use this to declare default gutters in your Sass file */\n/**********************************************************\n\nHelpers for applying margins/padding\n\n**********************************************************/\n/*\n  A function to get spacing value given the size key and viewport.\n\n  Usage:\n\n  @import 'src/styles/global_styles/spacing';\n\n  .someClass {\n    margin-right: spacing-value(small2, 'd');\n  }\n\n  ===> Output\n\n  .someClass {\n    margin-right: 32px;\n  }\n*/\n/*\n  Generate custom padding/margin with some given values.\n\n  The general idea here is to move away from hardcoding pixel values. Since\n  the design system is using a base unit of 8px, values should be a multiple\n  of the base unit.\n\n  This mixin will take in a property name and some values. These values should be a\n  multiplier of the desired pixel value.\n\n  However, if there is some need to use pixel values, this mixin can handle it.\n\n  Usage:\n\n  @import 'src/styles/global_styles/spacing';\n\n  .someClass {\n    @include spacing(margin, 8);\n    @include spacing(padding-right, 2);\n    @include spacing(padding, 12px 2.5);\n    @include spacing(margin-bottom, 3 !important);\n  }\n\n  ===> Output\n\n  .someClass {\n    margin: 64px;\n    padding-right: 16px;\n    padding: 12px 20px;\n    margin-bottom: 24px !important;\n  }\n*/\n.Toast_toastContainer__3CX6H {\n  /*\n    We're stretching the fixed container to touch the edges of the\n    browser. This was done so that the toasts can extend into this\n    fixed container.\n\n    Since this container will extend to the browser edges, we've\n    disabled pointer-events so the user can interact with the page\n    that immediately surrounds a toast. Pointer-events are reset in\n    the toast class.\n  */\n  right: 0;\n  bottom: 0;\n  left: 0;\n  transform: none;\n  pointer-events: none;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  transition: bottom 0.2s linear;\n  width: auto;\n  padding: 0px 16px; }\n\n.Toast_toast__3mfBa {\n  pointer-events: auto;\n  min-height: auto;\n  padding: 14px 16px;\n  margin-bottom: 0;\n  background-color: rgba(56, 76, 94, 0.9);\n  border-radius: 4px;\n  color: #fff;\n  font-size: 14px;\n  font-family: \"indivisible-variable\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-weight: 550;\n  letter-spacing: -0.35px;\n  line-height: 1; }\n  @media screen and (min-width: 576px) {\n    .Toast_toast__3mfBa {\n      font-size: 16px;\n      letter-spacing: -0.4px; } }\n\n.Toast_closeButton__1-bYj {\n  font-size: 12px;\n  color: #ccd4dd; }\n  @media (hover: hover) {\n    .Toast_closeButton__1-bYj:hover {\n      color: #fff; } }\n\n.Toast_toastBody__1A681 {\n  padding: 0;\n  margin: 0; }\n\n@keyframes Toast_up__3oYjt {\n  from {\n    transform: translate3d(0, 50vh, 0);\n    visibility: visible;\n    opacity: 0; }\n  to {\n    transform: translate3d(0, 0, 0);\n    opacity: 1; } }\n\n@keyframes Toast_down__3-gsj {\n  from {\n    transform: translate3d(0, 0, 0); }\n  to {\n    visibility: hidden;\n    transform: translate3d(0, 50vh, 0);\n    opacity: 0; } }\n\n.Toast_animateUp__2hfkl {\n  animation-fill-mode: both;\n  animation-duration: 0.3s;\n  animation-name: Toast_up__3oYjt; }\n\n.Toast_animateDown__auSQU {\n  animation-fill-mode: both;\n  animation-duration: 0.3s;\n  animation-name: Toast_down__3-gsj; }\n";
var styles$h = {"toastContainer":"Toast_toastContainer__3CX6H","toast":"Toast_toast__3mfBa","closeButton":"Toast_closeButton__1-bYj","toastBody":"Toast_toastBody__1A681","animateUp":"Toast_animateUp__2hfkl","up":"Toast_up__3oYjt","animateDown":"Toast_animateDown__auSQU","down":"Toast_down__3-gsj"};
styleInject(css_248z$h);

// Slide Transition that closely resembles what the Design team spec'd out
var CustomTransition = cssTransition({
    enter: styles$h.animateUp,
    exit: styles$h.animateDown,
});
// Close Button
var CloseButton = function (_a) {
    var closeToast = _a.closeToast;
    return (React.createElement("button", { type: "button", onClick: closeToast, className: "plainButton" },
        React.createElement(Icon, { name: "v2-close-icon", className: classnames('marginLeft-small', styles$h.closeButton) })));
};
// Toast Container
var HTToastContainer = function (props) {
    if (props === void 0) { props = {}; }
    var _a = props.className, className = _a === void 0 ? '' : _a, restProps = __rest(props, ["className"]);
    return (React.createElement(ToastContainer, __assign({ autoClose: 4000, closeButton: React.createElement(CloseButton, null), containerId: TOAST_CONTAINER_ID, draggable: false, enableMultiContainer: true, hideProgressBar: true, newestOnTop: true, position: toast.POSITION.BOTTOM_CENTER, transition: CustomTransition, className: classnames('marginBottom-medium', styles$h.toastContainer, className), toastClassName: classnames('marginTop-small', styles$h.toast), bodyClassName: styles$h.toastBody }, restProps)));
};

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$2 = 9007199254740991;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    funcTag$2 = '[object Function]',
    genTag$2 = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint$2 = /^(?:0|[1-9]\d*)$/;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes$1(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$5.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$5 = objectProto$5.toString;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$5.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$2 = Math.max;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys$1(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray$1(value) || isArguments$1(value))
    ? baseTimes$1(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$1.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex$2(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$1.call(object, key) && eq$1(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn$1(object) {
  if (!isObject$5(object)) {
    return nativeKeysIn$1(object);
  }
  var isProto = isPrototype$1(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$1.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax$2(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax$2(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall$1(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex$2(value, length) {
  length = length == null ? MAX_SAFE_INTEGER$2 : length;
  return !!length &&
    (typeof value == 'number' || reIsUint$2.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall$1(value, index, object) {
  if (!isObject$5(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike$2(object) && isIndex$2(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq$1(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype$1(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$5;

  return value === proto;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn$1(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq$1(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments$1(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject$1(value) && hasOwnProperty$1.call(value, 'callee') &&
    (!propertyIsEnumerable$1.call(value, 'callee') || objectToString$5.call(value) == argsTag$1);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray$1 = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike$2(value) {
  return value != null && isLength$2(value.length) && !isFunction$2(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject$1(value) {
  return isObjectLike$5(value) && isArrayLike$2(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$2(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject$5(value) ? objectToString$5.call(value) : '';
  return tag == funcTag$2 || tag == genTag$2;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength$2(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$2;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$5(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$5(value) {
  return !!value && typeof value == 'object';
}

/**
 * This method is like `_.assign` except that it iterates over own and
 * inherited source properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extend
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assign
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assignIn({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
 */
var assignIn = createAssigner(function(object, source) {
  copyObject(source, keysIn$1(source), object);
});

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn$1(object) {
  return isArrayLike$2(object) ? arrayLikeKeys$1(object, true) : baseKeysIn$1(object);
}

var lodash_assignin = assignIn;

var baseOpts = { containerId: TOAST_CONTAINER_ID };
var htToast = function (message, opts) {
    if (opts === void 0) { opts = {}; }
    return toast(message, __assign(__assign({}, baseOpts), opts));
};
var htBaseToast = {};
htBaseToast.success = function (message, opts) {
    if (opts === void 0) { opts = {}; }
    return toast.success(message, __assign(__assign({}, baseOpts), opts));
};
htBaseToast.info = function (message, opts) {
    if (opts === void 0) { opts = {}; }
    return toast.info(message, __assign(__assign({}, baseOpts), opts));
};
htBaseToast.error = function (message, opts) {
    if (opts === void 0) { opts = {}; }
    return toast.error(message, __assign(__assign({}, baseOpts), opts));
};
htBaseToast.warn = function (message, opts) {
    if (opts === void 0) { opts = {}; }
    return toast.warn(message, __assign(__assign({}, baseOpts), opts));
};
htBaseToast.warning = function (message, opts) {
    if (opts === void 0) { opts = {}; }
    return toast.warning(message, __assign(__assign({}, baseOpts), opts));
};
htBaseToast.dark = function (message, opts) {
    if (opts === void 0) { opts = {}; }
    return toast.dark(message, __assign(__assign({}, baseOpts), opts));
};
htBaseToast.clearWaitingQueue = function (params) {
    if (params === void 0) { params = {}; }
    return toast.clearWaitingQueue(__assign(__assign({}, baseOpts), params));
};
lodash_assignin(htToast, toast, htBaseToast);

var css_248z$i = ".Toggle_wrapper__14ZKx {\n  display: inline-block; }\n\n.Toggle_hiddenInput__2mxqL {\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px; }\n\n.Toggle_switch__1V_uq {\n  display: inline-block;\n  position: relative;\n  width: 48px;\n  height: 24px;\n  border-radius: 25px;\n  cursor: pointer; }\n  .Toggle_switch__1V_uq.Toggle_disabled__vmNFs {\n    opacity: 0.2;\n    pointer-events: none; }\n\n.Toggle_off__2rIYh {\n  background-color: #ccd4dd;\n  transition: all 0.1s; }\n\n.Toggle_on__3UXB9::before {\n  transform: translateX(20px); }\n\n.Toggle_on__3UXB9.Toggle_theme-default__140Y- {\n  background-color: #00cf7f; }\n\n.Toggle_off__2rIYh::before,\n.Toggle_on__3UXB9::before {\n  content: '';\n  position: absolute;\n  top: 2px;\n  left: 4px;\n  height: 20px;\n  width: 20px;\n  background-color: #fff;\n  border-radius: 50%;\n  transition: all 0.1s;\n  transition-delay: 0.01s; }\n";
var styles$i = {"wrapper":"Toggle_wrapper__14ZKx","hiddenInput":"Toggle_hiddenInput__2mxqL","switch":"Toggle_switch__1V_uq","disabled":"Toggle_disabled__vmNFs","off":"Toggle_off__2rIYh","on":"Toggle_on__3UXB9","theme-default":"Toggle_theme-default__140Y-"};
styleInject(css_248z$i);

var TEST_ID = 'StyleGuideToggle';
var inputIdCounter$3 = 0;
var Toggle = function (_a) {
    var _b;
    var _c = _a.classes, classes = _c === void 0 ? '' : _c, _d = _a.dataTestId, dataTestId = _d === void 0 ? TEST_ID : _d, _e = _a.id, id = _e === void 0 ? '' : _e, _f = _a.isDisabled, isDisabled = _f === void 0 ? false : _f, _g = _a.name, name = _g === void 0 ? '' : _g, _h = _a.onToggle, onToggle = _h === void 0 ? function () { } : _h, _j = _a.theme, theme = _j === void 0 ? 'default' : _j, _k = _a.toggleStatus, toggleStatus = _k === void 0 ? false : _k;
    var _l = __read(useState(id), 2), inputId = _l[0], setInputId = _l[1];
    useEffect(function () {
        if (!id) {
            setInputId("Toggle-" + inputIdCounter$3);
            inputIdCounter$3 += 1;
        }
    }, []);
    var toggle = function (e) {
        if (!isDisabled) {
            onToggle(e.target.checked);
        }
    };
    var toggleStyles = classnames(classes, styles$i.switch, (_b = {},
        _b[styles$i.off] = !toggleStatus,
        _b[styles$i.on] = toggleStatus,
        _b[styles$i["theme-" + theme]] = toggleStatus,
        _b[styles$i.disabled] = isDisabled,
        _b));
    return (React.createElement("div", { "data-testid": dataTestId, className: styles$i.wrapper },
        React.createElement("label", { className: toggleStyles, htmlFor: inputId, "data-testid": dataTestId + "-label" },
            React.createElement("input", { type: "checkbox", className: styles$i.hiddenInput, checked: toggleStatus, disabled: isDisabled, onChange: toggle, id: inputId, name: name, "data-testid": dataTestId + "-checkbox" }))));
};
var Toggle$1 = memo(Toggle);

var css_248z$j = "/* SPACING SCSS */\n@use \"sass:map\";\n/* Mobile first, so mobile doesn't have a breakpoint, it starts at 0px; */\n/*  mobile grid */\n/*  tablet grid */\n/*  desktop grid */\n/*  Maps */\n/*  Mixins */\n/*  Styles for .col property are declared separately from .col-xx-xx classes */\n/* Use this to declare custom gutters in your Sass file */\n/*  Use this to declare default gutters in your Sass file */\n/**********************************************************\n\nHelpers for applying margins/padding\n\n**********************************************************/\n/*\n  A function to get spacing value given the size key and viewport.\n\n  Usage:\n\n  @import 'src/styles/global_styles/spacing';\n\n  .someClass {\n    margin-right: spacing-value(small2, 'd');\n  }\n\n  ===> Output\n\n  .someClass {\n    margin-right: 32px;\n  }\n*/\n/*\n  Generate custom padding/margin with some given values.\n\n  The general idea here is to move away from hardcoding pixel values. Since\n  the design system is using a base unit of 8px, values should be a multiple\n  of the base unit.\n\n  This mixin will take in a property name and some values. These values should be a\n  multiplier of the desired pixel value.\n\n  However, if there is some need to use pixel values, this mixin can handle it.\n\n  Usage:\n\n  @import 'src/styles/global_styles/spacing';\n\n  .someClass {\n    @include spacing(margin, 8);\n    @include spacing(padding-right, 2);\n    @include spacing(padding, 12px 2.5);\n    @include spacing(margin-bottom, 3 !important);\n  }\n\n  ===> Output\n\n  .someClass {\n    margin: 64px;\n    padding-right: 16px;\n    padding: 12px 20px;\n    margin-bottom: 24px !important;\n  }\n*/\n.Tooltip_wrapper__1o4BM {\n  position: relative;\n  cursor: pointer;\n  display: inline-block; }\n\n/*\n  The design calls for the max width of the tooltip to be 200px.\n  However, the issue is that the width of an absolute child, unless\n  explicitly set, is relative to its parent's width.\n\n  The purpose of this div is to provide a wider base for its children\n  can grow into. It also provides a base for the positioning box.\n*/\n.Tooltip_scaffoldingBox__3AzlF {\n  position: absolute;\n  z-index: 1;\n  pointer-events: none;\n  min-width: 208px;\n  top: 0;\n  bottom: 0; }\n  .Tooltip_scaffoldingBox__3AzlF.Tooltip_hidden__1SWlB {\n    visibility: hidden; }\n  .Tooltip_scaffoldingBox__3AzlF.Tooltip_top__39Qyq, .Tooltip_scaffoldingBox__3AzlF.Tooltip_bottom__1qAJJ {\n    left: 50%;\n    transform: translateX(-50%); }\n    .Tooltip_scaffoldingBox__3AzlF.Tooltip_top__39Qyq.Tooltip_align-right__fi56A, .Tooltip_scaffoldingBox__3AzlF.Tooltip_bottom__1qAJJ.Tooltip_align-right__fi56A {\n      left: auto;\n      transform: none;\n      right: 0; }\n    .Tooltip_scaffoldingBox__3AzlF.Tooltip_top__39Qyq.Tooltip_align-left__8bveN, .Tooltip_scaffoldingBox__3AzlF.Tooltip_bottom__1qAJJ.Tooltip_align-left__8bveN {\n      right: auto;\n      transform: none;\n      left: 0; }\n  .Tooltip_scaffoldingBox__3AzlF.Tooltip_right__3e2oL {\n    left: 100%; }\n  .Tooltip_scaffoldingBox__3AzlF.Tooltip_left__3YaSb {\n    right: 100%; }\n\n/*\n  With the scaffolding box in place, this div can be positioned and aligned.\n\n  The width is also set to 100% so its child, the tooltip, can grow freely\n  within it. `pointer-events` is also set to `none` so mouse events are not\n  triggered.\n*/\n.Tooltip_positioningBox__3bxY0 {\n  position: absolute;\n  z-index: 1;\n  pointer-events: none;\n  width: 100%; }\n  .Tooltip_positioningBox__3bxY0.Tooltip_top__39Qyq {\n    left: 50%;\n    transform: translate3d(-50%, 0, 0);\n    bottom: 100%;\n    text-align: center; }\n  .Tooltip_positioningBox__3bxY0.Tooltip_right__3e2oL {\n    top: 50%;\n    transform: translate3d(0%, -50%, 0);\n    text-align: left; }\n  .Tooltip_positioningBox__3bxY0.Tooltip_bottom__1qAJJ {\n    left: 50%;\n    transform: translate3d(-50%, 0, 0);\n    top: 100%;\n    text-align: center; }\n  .Tooltip_positioningBox__3bxY0.Tooltip_left__3YaSb {\n    top: 50%;\n    transform: translate3d(0%, -50%, 0);\n    text-align: right; }\n  .Tooltip_positioningBox__3bxY0.Tooltip_top__39Qyq.Tooltip_align-right__fi56A, .Tooltip_positioningBox__3bxY0.Tooltip_bottom__1qAJJ.Tooltip_align-right__fi56A {\n    text-align: right; }\n  .Tooltip_positioningBox__3bxY0.Tooltip_top__39Qyq.Tooltip_align-left__8bveN, .Tooltip_positioningBox__3bxY0.Tooltip_bottom__1qAJJ.Tooltip_align-left__8bveN {\n    text-align: left; }\n  .Tooltip_positioningBox__3bxY0.Tooltip_right__3e2oL.Tooltip_align-top__3lgof, .Tooltip_positioningBox__3bxY0.Tooltip_left__3YaSb.Tooltip_align-top__3lgof {\n    top: 0;\n    bottom: auto;\n    transform: none; }\n  .Tooltip_positioningBox__3bxY0.Tooltip_right__3e2oL.Tooltip_align-bottom__3rTDM, .Tooltip_positioningBox__3bxY0.Tooltip_left__3YaSb.Tooltip_align-bottom__3rTDM {\n    top: auto;\n    bottom: 0;\n    transform: none; }\n\n/*\n  This div merely provides a bridge between the triggering element\n  and the actual tooltip. The padding will not trigger the onMouseLeave\n  event, so the tooltip will not disappear.\n*/\n.Tooltip_hoverScaffoldingBox__1R1W2 {\n  pointer-events: auto;\n  display: inline-block; }\n  .Tooltip_hoverScaffoldingBox__1R1W2.Tooltip_top__39Qyq {\n    padding-bottom: 8px; }\n  .Tooltip_hoverScaffoldingBox__1R1W2.Tooltip_right__3e2oL {\n    padding-left: 8px; }\n  .Tooltip_hoverScaffoldingBox__1R1W2.Tooltip_bottom__1qAJJ {\n    padding-top: 8px; }\n  .Tooltip_hoverScaffoldingBox__1R1W2.Tooltip_left__3YaSb {\n    padding-right: 8px; }\n\n/*\n  And finally, this div is for the actual content. With the parent boxes\n  in place, this box can grow freely up until its max-width.\n*/\n.Tooltip_tipBox__PpIWP {\n  pointer-events: auto;\n  max-width: 200px;\n  background-color: #fbfdfe;\n  border-radius: 2px;\n  border: 1px solid #ccd4dd;\n  box-shadow: 0 16px 36px 8px rgba(38, 55, 70, 0.06);\n  padding: 8px 12px;\n  text-align: center;\n  white-space: normal; }\n";
var styles$j = {"wrapper":"Tooltip_wrapper__1o4BM","scaffoldingBox":"Tooltip_scaffoldingBox__3AzlF","hidden":"Tooltip_hidden__1SWlB","top":"Tooltip_top__39Qyq","bottom":"Tooltip_bottom__1qAJJ","align-right":"Tooltip_align-right__fi56A","align-left":"Tooltip_align-left__8bveN","right":"Tooltip_right__3e2oL","left":"Tooltip_left__3YaSb","positioningBox":"Tooltip_positioningBox__3bxY0","align-top":"Tooltip_align-top__3lgof","align-bottom":"Tooltip_align-bottom__3rTDM","hoverScaffoldingBox":"Tooltip_hoverScaffoldingBox__1R1W2","tipBox":"Tooltip_tipBox__PpIWP"};
styleInject(css_248z$j);

var TipBox = function (_a) {
    var show = _a.show, content = _a.content, position = _a.position, align = _a.align;
    var _b = __read(useState(false), 2), visible = _b[0], setVisible = _b[1];
    var tipBoxRef = useRef();
    var modifiedPosition = useRef(position);
    var modifiedAlignment = useRef(align);
    /*
      This applies rudimentary logic to detect if the tooltip is extending
      beyond the browser window. If it extends beyond, then change its position
      and alignment.
    */
    useEffect(function () {
        if (show) {
            var _a = tipBoxRef.current.getBoundingClientRect(), tipBoxLeft = _a.left, tipBoxRight = _a.right;
            var windowWidth = window.innerWidth;
            if (position === 'top' || position === 'bottom') {
                if (tipBoxRight > windowWidth) {
                    modifiedAlignment.current = 'right';
                }
                else if (tipBoxLeft < 0) {
                    modifiedAlignment.current = 'left';
                }
            }
            else if (position === 'left') {
                if (tipBoxLeft < 0) {
                    modifiedAlignment.current = 'left';
                    modifiedPosition.current = 'bottom';
                }
            }
            else if (position === 'right') {
                if (tipBoxRight > windowWidth) {
                    modifiedAlignment.current = 'right';
                    modifiedPosition.current = 'bottom';
                }
            }
            setVisible(true);
        }
        else {
            setVisible(false);
            modifiedPosition.current = position;
            modifiedAlignment.current = align;
        }
    }, [show]);
    var positionStyle = styles$j[modifiedPosition.current];
    var alignStyle = styles$j["align-" + modifiedAlignment.current];
    var visibilityStyle = visible ? '' : styles$j.hidden;
    return (React.createElement("div", { "data-testid": "tooltip-box", className: classnames(styles$j.scaffoldingBox, positionStyle, alignStyle, visibilityStyle) },
        React.createElement("div", { className: classnames(styles$j.positioningBox, positionStyle, alignStyle) },
            React.createElement("div", { className: classnames(styles$j.hoverScaffoldingBox, positionStyle) },
                React.createElement("div", { ref: tipBoxRef, className: styles$j.tipBox },
                    React.createElement("p", { className: "caption" }, content))))));
};
var Tooltip = function (_a) {
    var children = _a.children, _b = _a.hoverDuration, hoverDuration = _b === void 0 ? 200 : _b, _c = _a.useHover, useHover = _c === void 0 ? true : _c, _d = _a.content, content = _d === void 0 ? '' : _d, _e = _a.position, position = _e === void 0 ? 'bottom' : _e, _f = _a.align, align = _f === void 0 ? 'center' : _f, _g = _a.wrapperClass, wrapperClass = _g === void 0 ? '' : _g, _h = _a.dataTestId, dataTestId = _h === void 0 ? 'StyleGuideTooltip' : _h;
    var _j = __read(useState(false), 2), showTip = _j[0], setShowTip = _j[1];
    var touchEnabled = useRef(false);
    var hoverEnabled = useRef(false);
    var timeoutId = useRef();
    var containerRef = useRef();
    var onTouchStart = useCallback(function () {
        touchEnabled.current = true;
    }, []);
    var onMouseEnter = useCallback(function () {
        if (!touchEnabled.current && useHover) {
            timeoutId.current = setTimeout(function () { return setShowTip(true); }, hoverDuration);
            hoverEnabled.current = true;
        }
        touchEnabled.current = false;
    }, []);
    var onClick = useCallback(function () {
        if (!hoverEnabled.current) {
            setShowTip(!showTip);
        }
    }, [showTip]);
    var onMouseLeave = useCallback(function () {
        clearTimeout(timeoutId.current);
        if (hoverEnabled.current && showTip && useHover) {
            setShowTip(false);
        }
        hoverEnabled.current = false;
    }, [showTip]);
    useEffect(function () {
        return function () {
            clearTimeout(timeoutId.current);
        };
    }, []);
    /*
      Close self on touch-enabled devices if user taps elsewhere.
      This method isn't great for browser performance if there are many
      instances of Tooltip on a page.
    */
    var closeOtherTooltips = useCallback(function (e) {
        if (!containerRef.current.contains(e.target)) {
            setShowTip(false);
        }
    }, []);
    useEventListener({ eventName: 'touchstart', handler: closeOtherTooltips });
    /**
     Close the tooltip if the user scrolls
     */
    var handleCloseOnScroll = lodash_throttle(function () {
        if (showTip) {
            setShowTip(false);
        }
    }, 500);
    useEventListener({ eventName: 'scroll', handler: handleCloseOnScroll });
    return (React.createElement("div", { onTouchStart: onTouchStart, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onClick: onClick, ref: containerRef, className: classnames(styles$j.wrapper, wrapperClass), "data-testid": dataTestId },
        children,
        React.createElement(TipBox, { show: showTip, content: content, position: position, align: align })));
};

export { Accordion$1 as Accordion, AccordionGroup$1 as AccordionGroup, AnimatedCalloutBox, Avatar$1 as Avatar, BadgeTypes as BADGE_TYPES, BREAKPOINTS, BUTTON_THEMES, Badge$1 as Badge, Button, CalloutBox, CalloutBoxThemes, Checkbox, CheckboxGroup$1 as CheckboxGroup, Size as ELEMENT_SIZE, ErrorMessage, Form, Grid, HTToastContainer, Icon, Input as InputField, Label, LoadersComponent as LoaderComponent, LoadersPage as LoaderPage, Modal$1 as Modal, Panel, PlainModal$1 as PlainModal, Radio, RadioGroup$1 as RadioGroup, SelectField, TOAST_CONTAINER_ID, TextArea, Toggle$1 as Toggle, Tooltip, htToast };
//# sourceMappingURL=index.js.map
